import appConfig from "./../../App.config.js"

// GRAPHQL
import crossFetch from "cross-fetch"
//import { ApolloClient } from "apollo-boost"
//import { HttpLink } from "apollo-link-http";
//import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client"
import {
    // VAPOR2
    READ_USER_DATA_QUERY,
    WRITE_FBACK_MUTATION,
    SET_USER_MUTATION,
    WRITE_POSTS_MUTATION,
    GET_ISSUE_TRENDS_QUERY,
    GET_STATEMENT_TRENDS_QUERY,
    GET_DRIVES_QUERY,
    SAVE_USER_MUTATION,
    COPY_USER_POSTS_MUTATION,
    GET_SUB_GEOS_QUERY,
    GET_VALID_GEOS_QUERY,
    GET_STATEMENT_TRENDS_V2_QUERY,
    GET_ISSUE_TRENDS_V2_QUERY,
} from "../../gql/queries"


// UTILS
import * as _ from "lodash"
import * as moment from "moment"
import * as slugid from "slugid"
import * as flat from "flat"

// eslint-disable-next-line
import { setWeek, getWeek, addDays, addWeeks, add, sub,
	 // eslint-disable-next-line
	 differenceInMilliseconds,
	 differenceInWeeks,
	 differenceInDays,
	 differenceInHours,
	 intervalToDuration,
	 set,
	 parse
       } from "date-fns"

import { zonedTimeToUtc } from "date-fns-tz"

import {
    round,
    jsonDeleteKeys,
    jsonDeleteValues,
    jsonHasPath,
    deepCopy,
    distinct,
} from "../../components/Utils.js"

const log = appConfig.getLogger("BL")
// log.trace.enabled = true;


// filters
const issueFilter = (uuid) => {
    return t => {
	return t.issue.uuid === uuid
    }
}

const weekFilter = (weekNum) => {
    return t => {
	return t.WEEK_N === weekNum
    }
}



/*
// set is just 1 or 0 I think
const maxNumberReducer = (fieldName) => {
    return (a,b) => {
	if(a[fieldName]) { // first time
            const aVal = Number(a[fieldName])
            const bVal = Number(b[fieldName])
	    const retVal = aVal > bVal ? aVal : bVal
	    // log.trace("maxNumberReducer(): a =", a)
	    // log.trace("maxNumberReducer(): b =", a)
	    // log.trace("maxNumberReducer(): retVal =", retVal)
	    return retVal
	}
        return a > b[fieldName] ? a : b[fieldName]
    }
}
*/

/*
const minNumberReducer = (fieldName) => {
    return (a,b) => {
	if(a[fieldName]) { // first time
            const aVal = Number(a[fieldName])
            const bVal = Number(b[fieldName])
            return aVal < bVal ? aVal : bVal
	}
        return a < b[fieldName] ? a : b[fieldName]
    }
}
*/

const fieldFilter = (fieldName, fieldValue) => {
    return t => {
	const split = fieldName.split(".")
	if(split.length === 2) {
	    return t[split[0]][split[1]] === fieldValue
	} else {
	    return t[fieldName] === fieldValue
	}
    }
}

const sumReducer = (fieldName) => {
    return (sum,t) => {
	if(sum[fieldName]) { // first time
	    return Number(sum[fieldName]) + Number(t[fieldName])
	}
	sum += Number(t[fieldName])
	return sum
    }
}

const avgReducer = (fieldName) => {
    return (obj, t, idx, src) => {
	if(!obj.count) {
	    // this is the first element
	    return {
		avg: (Number(obj[fieldName]) + Number(t[fieldName]))/2,
		count: 2
	    }
	}
	obj.avg = (obj.avg * obj.count + Number(t[fieldName])) / ++obj.count
	if(idx === (src.length - 1)) {
	    // this is a last element to return just the avg number, not the object
	    // with a counter
	    return obj.avg
	} else {
	    return obj
	}
    }
}



const getUserFromData = (userData) => {
    // we map only a limited
    // number of attributes here
    // TODO: userData, should be a separate
    // query with a "user" object in the future
    // just making it simple for now with 1 query
    let user = {
        uuid: userData.uuid,
        name: userData.name,
        loginLevel: userData.loginLevel,
        address: userData.address,
    }
    return user
}

const getContactsFromData = (userData) => {
    return userData.contacts
}

const getIssuesFromData = (userData) => {
    let issues = []
    for (let len = userData.statements.length, i=0; i<len; ++i) {
        let issue = userData.statements[i].issue
        if(!_.find(issues, [ "uuid", issue.uuid] )) {
            issues.push(issue)
        }
    }
    return issues
}

const getStatementsFromUserData = (userData) => {
    return userData.statements
}


const getContactsFromUserData = (userData) => {
    return userData.contacts
}

//
// MOCK DATA
//

const _dist13ZipCodes_full = [94002, 94005, 94010, 94014, 94019, 94020, 94021, 94022, 94024, 94025, 94027, 94028, 94030, 94037, 94038, 94040, 94041, 94043, 94044, 94060, 94061, 94062, 94063, 94065, 94066, 94070, 94074, 94080, 94085, 94086, 94087, 94089, 94128, 94301, 94303, 94304, 94305, 94306, 94401, 94402, 94403, 94404, 95002, 95014, 95033, 95051, 95070]

const _dist15ZipCodes_full = [95013,94024,94087,94550,95008,95009,95011,95014,95015,95030,95031,95032,95033,95035,95037,95042,95050,95051,95070,95071,95103,95106,95108,95109,95110,95111,95112,95113,95115,95116,95117,95118,95119,95120,95121,95122,95123,95124,95125,95126,95127,95128,95129,95130,95132,95133,95135,95136,95138,95139,95140,95141,95148,95151,95153,95154,95155,95156,95157,95158,95159,95160,95170,95172,95173,95192,95196,95363]


const _dist13ZipCodes = [94010, 94025, 94027]
const _dist15ZipCodes = [ 95110 ]

const dist13ZipCodes = _dist13ZipCodes.map(zip => "" + zip)
const dist15ZipCodes = _dist15ZipCodes.map(zip => "" + zip)


const tempMockMapGeos = [
    {
	state: {
	    code: "CA"
	}
    }
    ,{
	state: {
	    code: "AZ"
	}
    }
]



/*
const getIssuesFromUserData_old = (userData) => {
    let issues = []
    for (let len = userData.statements.length, i=0; i<len; ++i) {
        let issue = userData.statements[i].issue
        if(!_.find(issues, [ "uuid", issue.uuid] )) {
            issues.push(issue)
        }
    }
    return issues
}
*/

// TODO: for now use slug for uniquness, we'll use uuid again
// when we set issues with unique uuid
// DBUG this thing
const getIssuesFromUserData = (userData) => {
    const issues = []

    log.trace("getIssuesFromUserData(): usrData.statements =", userData.statements)

    for (let i in userData.statements) {
	const statement = JSON.parse(JSON.stringify(userData.statements[i]))
	log.trace("getIssuesFromUserData(): statement =", statement)
	if (!issues.find(issue => {
	    if(issue.uuid === statement.issue.uuid) {
		return true
	    } else {
		return false
	    }
	})) {
            const issue = userData.statements[i].issue
	    log.trace("getIssuesFromUserData(): NOT FOUND, pushing issue =", issue)
	    issues.push(issue)
	} else {
	    log.trace("getIssuesFromUserData(): FOUND")
	}
	
    }

    log.trace("getIssuesFromUserData(): returning issues =", issues)
    return issues
    
}


const getStatementsFromData = (userData) => {
    return userData.statements
}


const getVaporURL = () => {
    // Apollo

    let vaporURL
    if(process.env.REACT_APP_VAPOR_ENV === "devshell") {
	log.trace("getVaporURL(): I am DEVSHELL")	
        // vaporURL = "http://192.168.1.212:30002/graphql"
        // vaporURL="http://10.99.11.218:30002/graphql"
        // vaporURL="http://10.99.11.191:30002/graphql"
        // vaporURL="http://localhost:30002/graphql"
	//
	// vaporURL = "http://192.168.1.212:50030/graphql"
        // vaporURL = "https://vapor.dev.lightning.reviews/graphql"
	vaporURL = "http://localhost:4000" // vapor2
    } else if(process.env.REACT_APP_VAPOR_ENV === "demo") {
	log.trace("getVaporURL(): I am DEMO")	
        vaporURL = "https://vapor.demo.lightning.reviews/graphql"
    } else if(process.env.REACT_APP_VAPOR_ENV === "dev") {
	log.trace("getVaporURL(): I am DEV")	
        //vaporURL = "https://vapor.dev.lightning.reviews/graphql"
	vaporURL = "https://vapor.dev.lightning.live"
    }

    return vaporURL
}

const getGqlClient = () => {
    log.trace("getGqlClient(): START")

    let clientFetch
    if(typeof fetch === "undefined") {
        clientFetch = crossFetch
    } else {
        clientFetch = fetch
    }
    
    const gqlClient = new ApolloClient({
        //uri: "http://localhost:30002/graphql"
        //            link: new HttpLink({ uri: 'http://localhost:30002/graphql' }),
        //            link: new HttpLink({ uri: 'http://192.168.1.212:30002/graphql' }),
        // link: new HttpLink({ uri: "http://vapor.demo.lightning.reviews/graphql" }),
	link: new HttpLink({
	    uri: getVaporURL(),
            fetch: clientFetch,
	}),
	
        cache: new InMemoryCache()
    })

    log.trace("getGqlClient(): FINISH")

    return gqlClient
}

/*
const getAllData = (user, callbacks) => {
    log.trace("getAllData(): START")
    log.trace("getAllData(): getVaporURL() =", getVaporURL())
    log.trace("getAllData(): user =", user)
    log.trace("getAllData(): FINISH")

    const gqlClient = getGqlClient()

    log.trace("getAllData(): gqlClient =", gqlClient)

    let getUserQueryConfig = {
        query: getUserDataByUserUUIDQuery,
        variables: {
	    uuid: user.uuid,
	    store: "postground"
        }
    }

    gqlClient.query(getUserQueryConfig)
        .then(result => {
	    log.trace("getAllData(): PROMISE: result.data.user =", result.data.user)
	    if(!result.data.user)
		callbacks.onError(result)
	    else 
		callbacks.onResult(result)
	}).catch (error => {
	    // log.trace("bl: getAllData(): PROMISE: ERROR: error =", error)
	    callbacks.onError(error)
	})
}
*/

const getIssuesFilters = (args) => {
    log.trace("getIssuesFilters(): args =", args)

    let filters = {
        geoStates: [],
        geoZips: [],
	levels: []
    }

    // do something if there are no args at all
    if(!args) {
	log.error("getIssuesFilters(): there are no args, returning empty filters")
	return filters
    }

    if(args.level === "Federal"
       && args.geoState === "All-States") {
	//
	// S1
	// Initial top level
	log.trace("getIssuesFilters(): //")
	log.trace("getIssuesFilters(): // S1")
	log.trace("getIssuesFilters(): //")
	filters = {
	    levels: ["Federal"],
	    levelCurrent: args.level,
            geoStates: ["CA", "NY", "All-States"],
	    geoStateCurrent: args.geoState,
            geoZips: [],
	}
    } else if (args.level === "Federal"
	       && args.geoState !== "All-State") {
	//
	// S2
	// Select state
	log.trace("getIssuesFilters(): //")
	log.trace("getIssuesFilters(): // S2")
	log.trace("getIssuesFilters(): //")
	filters = {
	    levels: ["Federal", "State", "All-Levels"],
	    levelCurrent: args.level,
            geoStates: ["CA", "NY", "All-States"],
	    geoStateCurrent: args.geoState,
            geoZips: [],
	}

	// setup zips in the state
	if(filters.geoStateCurrent === "CA") {
	    filters = {
		...filters,
		geoZips: ["94010", "94025"],
		isVisibleGeoZip: true
	    }
	}
	
    } else if(args.level === "All-Levels"
	      && args.geoState) {
	//
	// S3
	// Select level
	log.trace("getIssuesFilters(): //")
	log.trace("getIssuesFilters(): // S3")
	log.trace("getIssuesFilters(): //")
	filters = {
	    levels: ["Federal", "State", "All-Levels"],
	    levelCurrent: args.level,
            geoStates: ["CA", "NY", "All-States"],
	    geoStateCurrent: args.geoState,
            geoZips: [],
	}
    } else if(args.level === "State"
	      && args.geoState) {
	//
	// S4
	// Select level
	log.trace("getIssuesFilters(): //")
	log.trace("getIssuesFilters(): // S4")
	log.trace("getIssuesFilters(): //")
	filters = {
	    levels: ["Federal", "State", "All-Levels"],
	    levelCurrent: args.level,
            geoStates: ["CA", "NY", "All-States"],
	    geoStateCurrent: args.geoState,
            geoZips: [],
	}
    }
    
    // {filters.isVisibleGeoZip ?
    log.trace("getIssuesFilters(): returning filters =", filters)
    return filters
}

const genMockIssuesData = () => {

    // eslint-disable-next-line
    let countsArray = []
    let changeArray = []
    let trendArray = []
    let pct1dChangeArray = []

    let issueArray = [
	// federal, state = ALL, zip = ALL
	{uuid: "us-fed-mock-daca-all-all", txt: "DACA", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 2, CHECK_COUNT: 90015},
	{uuid: "us-fed-mock-charter-all-all", txt: "Charter schools", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 1, CHECK_COUNT: 105430 },
	{uuid: "us-fed-mock-college-all-all", txt: "Free college tuition for all", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 3, CHECK_COUNT: 82120},
	{uuid: "us-fed-mock-abortion-all-all", txt: "Abortion laws", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 4, CHECK_COUNT: 80501 },
	{uuid: "us-fed-mock-iran-all-all", txt: "Iran", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 5, CHECK_COUNT: 80132},
	{uuid: "us-fed-mock-census-all-all", txt: "Census questions about immigration status", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 6, CHECK_COUNT: 80032},
	{uuid: "us-fed-mock-climate-all-all", txt: "Climate change", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 7, CHECK_COUNT: 76001},
	{uuid: "us-fed-mock-china-all-all", txt: "Tariffs with China", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 8, CHECK_COUNT: 72031},
	{uuid: "us-fed-mock-impeachment-all-all", txt: "Impeachment", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 9, CHECK_COUNT: 71555},
	{uuid: "us-fed-mock-infra-all-all", txt: "Infrastructure funding", level: "Federal",geoState: "ALL", geoZip: "ALL", RANK: 10, CHECK_COUNT: 70004},
	{uuid: "us-fed-mock-border-all-all", txt: "Southern border", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 11, CHECK_COUNT: 70002},
	{uuid: "us-fed-mock-wage-all-all", txt: "Raising the minimum wage", level: "Federal", geoState: "ALL", geoZip: "ALL", RANK: 12, CHECK_COUNT: 66012},
	// state, state = ALL, zip = ALL
	{uuid: "us-state-sb50-all-all", txt: "SB50 - overrides local zoning with mandated housing density near transit", level: "State",geoZip: "ALL", RANK: 13, CHECK_COUNT: 64043},
	{uuid: "us-state-gas-all-all", txt: "Gas tax increases", level: "State", geoState: "ALL", geoZip: "ALL", RANK: 14, CHECK_COUNT: 64211},
	{uuid: "us-state-sanct-all-all", txt: "Sanctuary state", level: "State", geoState: "ALL", geoZip: "ALL", RANK: 15, CHECK_COUNT: 64155},
	{uuid: "us-state-health-all-all", txt: "Free health care for illegals", level: "State", geoState: "ALL", geoZip: "ALL", RANK: 16, CHECK_COUNT: 63313},
	{uuid: "us-state-rail-all-all", txt: "High speed rail project", level: "State", geoState: "ALL", geoZip: "ALL", RANK: 17, CHECK_COUNT: 63212},
	{uuid: "us-state-mj-all-all", txt: "Recreational marijuana", level: "State", geoState: "ALL", geoZip: "ALL", RANK: 18, CHECK_COUNT: 62544},
	{uuid: "us-state-sigs-all-all", txt: "eCigarettes", level: "State",geoState: "ALL", geoZip: "ALL", RANK: 19, CHECK_COUNT: 52566},


	// federal, state = CA, zip = ALL
	{uuid: "us-fed-mock-daca-ca-all", txt: "DACA", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 2, CHECK_COUNT: 90015},
	{uuid: "us-fed-mock-charter-ca-all", txt: "Charter schools", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 11, CHECK_COUNT: 71020 },
	{uuid: "us-fed-mock-college-ca-all", txt: "Free college tuition for all", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 3, CHECK_COUNT: 71001},
	{uuid: "us-fed-mock-abortion-ca-all", txt: "Abortion laws", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 4, CHECK_COUNT: 80501 },
	{uuid: "us-fed-mock-iran-ca-all", txt: "Iran", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 5, CHECK_COUNT: 80132},
	{uuid: "us-fed-mock-census-ca-all", txt: "Census questions about immigration status", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 6, CHECK_COUNT: 80032},
	{uuid: "us-fed-mock-climate-ca-all", txt: "Climate change", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 7, CHECK_COUNT: 76001},
	{uuid: "us-fed-mock-china-ca-all", txt: "Tariffs with China", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 8, CHECK_COUNT: 72031},
	{uuid: "us-fed-mock-impeachment-ca-all", txt: "Impeachment", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 9, CHECK_COUNT: 71022},
	{uuid: "us-fed-mock-infra-ca-all", txt: "Infrastructure funding", level: "Federal",geoState: "CA", geoZip: "ALL", RANK: 10, CHECK_COUNT: 71021},
	{uuid: "us-fed-mock-border-ca-all", txt: "Southern border", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 1, CHECK_COUNT: 105430},
	{uuid: "us-fed-mock-wage-ca-all", txt: "Raising the minimum wage", level: "Federal", geoState: "CA", geoZip: "ALL", RANK: 12, CHECK_COUNT: 66012},
	// state, state = CA, zip = ALL
	{uuid: "us-state-sb50-ca-all", txt: "SB50 - overrides local zoning with mandated housing density near transit", level: "State",geoZip: "ALL", RANK: 13, CHECK_COUNT: 64043},
	{uuid: "us-state-gas-ca-all", txt: "Gas tax increases", level: "State", geoState: "CA", geoZip: "ALL", RANK: 14, CHECK_COUNT: 64211},
	{uuid: "us-state-sanct-ca-all", txt: "Sanctuary state", level: "State", geoState: "CA", geoZip: "ALL", RANK: 15, CHECK_COUNT: 63313},
	{uuid: "us-state-health-ca-all", txt: "Free health care for illegals", level: "State", geoState: "CA", geoZip: "ALL", RANK: 16, CHECK_COUNT: 63212},
	{uuid: "us-state-rail-ca-all", txt: "High speed rail project", level: "State", geoState: "CA", geoZip: "ALL", RANK: 17, CHECK_COUNT: 63212},
	{uuid: "us-state-mj-ca-all", txt: "Recreational marijuana", level: "State", geoState: "CA", geoZip: "ALL", RANK: 18, CHECK_COUNT: 62544},
	{uuid: "us-state-sigs-ca-all", txt: "eCigarettes", level: "State", geoState: "CA", geoZip: "ALL", RANK: 19, CHECK_COUNT: 52566},

	// federal, state = CA, zip = 94010
	{uuid: "us-fed-mock-daca-ca-94010", txt: "DACA", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 1, CHECK_COUNT: 105430},
	{uuid: "us-fed-mock-charter-ca-94010", txt: "Charter schools", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 2, CHECK_COUNT: 92234 },
	{uuid: "us-fed-mock-college-ca-94010", txt: "Free college tuition for all", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 11, CHECK_COUNT: 70002},
	{uuid: "us-fed-mock-abortion-ca-94010", txt: "Abortion laws", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 4, CHECK_COUNT: 80501 },
	{uuid: "us-fed-mock-iran-ca-94010", txt: "Iran", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 5, CHECK_COUNT: 80132},
	{uuid: "us-fed-mock-census-ca-94010", txt: "Census questions about immigration status", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 6, CHECK_COUNT: 80032},
	{uuid: "us-fed-mock-climate-ca-94010", txt: "Climate change", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 7, CHECK_COUNT: 76001},
	{uuid: "us-fed-mock-china-ca-94010", txt: "Tariffs with China", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 8, CHECK_COUNT: 72031},
	{uuid: "us-fed-mock-impeachment-ca-94010", txt: "Impeachment", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 9, CHECK_COUNT: 71022},
	{uuid: "us-fed-mock-infra-ca-94010", txt: "Infrastructure funding", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 10, CHECK_COUNT: 71015},
	{uuid: "us-fed-mock-border-ca-94010", txt: "Southern border", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 3, CHECK_COUNT: 91000},
	{uuid: "us-fed-mock-wage-ca-94010", txt: "Raising the minimum wage", level: "Federal", geoState: "CA", geoZip: "94010", RANK: 12, CHECK_COUNT: 66001},
	// state, state = CA, zip = 94010
	{uuid: "us-state-sb50-ca-94010", txt: "SB50 - overrides local zoning with mandated housing density near transit", level: "State",geoZip: "94010", RANK: 13, CHECK_COUNT: 64043},
	{uuid: "us-state-gas-ca-94010", txt: "Gas tax increases", level: "State", geoState: "CA", geoZip: "94010", RANK: 14, CHECK_COUNT: 64211},
	{uuid: "us-state-sanct-ca-94010", txt: "Sanctuary state", level: "State",geoZip: "94010", RANK: 15, CHECK_COUNT: 63313},
	{uuid: "us-state-health-ca-94010", txt: "Free health care for illegals", level: "State", geoState: "CA", geoZip: "94010", RANK: 16, CHECK_COUNT: 63212},
	{uuid: "us-state-rail-ca-94010", txt: "High speed rail project", level: "State", geoState: "CA", geoZip: "94010", RANK: 17, CHECK_COUNT: 63212},
	{uuid: "us-state-mj-ca-94010", txt: "Recreational marijuana", level: "State",geoState: "CA", geoZip: "94010", RANK: 18, CHECK_COUNT: 62544},
	{uuid: "us-state-sigs-ca-94010", txt: "eCigarettes", level: "State", geoState: "CA", geoZip: "94010", RANK: 19, CHECK_COUNT: 52566},

	// zip = 12345
	{uuid: "us-nd-atheletes-all-12345", txt: "Athletes \"play for pay\"", level: "Federal", geoZip: "12345", drive: "Notre Dame Intro", RANK: 1, CHECK_COUNT: 76001},
	{uuid: "us-nd-legacy-all-12345", txt: "Legacy admissions", level: "Federal", geoZip: "12345", drive: "Notre Dame Intro", RANK: 2, CHECK_COUNT: 63212},
	{uuid: "us-nd-nd-all-12345", txt: "Notre Dame", level: "Federal", geoZip: "12345", drive: "Notre Dame Intro", RANK: 3, CHECK_COUNT: 52566},
	
    ]

    // eslint-disable-next-line
    countsArray = [
	1000,
	15000,
	30000,
	50000,
	60000,
	35000,
	100000,
	40000,
	10000,
	20000,
	45677,
	54000,
	34000,
	100000,
	40000,
	10000,
	20000,
	45677,
	54000,
	34000,
	45677,
	54000
    ]
    
    for(let i = 1; i <= issueArray.length; i++) {
        let startVal = i >= 4 ? (i%4 + 1) : i

        let finVal = i >= 5 ? (i%5 + 1) : i
        
        trendArray.push({
	    name: "Rank Trend (1w)",
	    data: [
                { "date": moment("2019-11-10").toDate(), "value": startVal },
                { "date": moment("2019-11-11").toDate(), "value": 2 },
                { "date": moment("2019-11-12").toDate(), "value": 3 },
                { "date": moment("2019-11-13").toDate(), "value": 3 },
                { "date": moment("2019-11-14").toDate(), "value": 2 },
                { "date": moment("2019-11-15").toDate(), "value": 1 },
                { "date": moment("2019-11-16").toDate(), "value": finVal }
	    ]
        })

        changeArray.push({
	    name: "Rank Change (1w)",
	    data: [
                { "category": "blah", "value": finVal, "priv": startVal },
	    ]
        })

        let pctChange = 0
        let prevVal = 3
        if(finVal < prevVal) {
	    pctChange = (prevVal - finVal) * (1/5) * 100 // 1 of max points
        } else if(finVal > prevVal) {
	    pctChange = -(finVal - prevVal) * (1/5) * 100 // 1 of max point
        }
        
        pct1dChangeArray.push(
	    pctChange
        )
        
    }
    
    return  issueArray.map((issue, index) => {
	// {uuid: "uuid-1", place: 1, name: "Issue 1", counts: 10000, RankAvgCurrent: 1}
	return {
	    issue: {
		uuid: issueArray[index].uuid,
		txt: issueArray[index].txt,
		level: issueArray[index].level,
		geoState: issueArray[index].geoState,
		geoZip: issueArray[index].geoZip,
		drive: issueArray[index].drive,
		state: "STATE_TBD"
	    },
	    place: index,
	    RANK: issueArray[index].RANK,
	    CHECK_COUNT: issueArray[index].CHECK_COUNT,
	    CHECK_COUNT_TREND: trendArray[index]
	    //	    counts: countsArray[index],
	    //	    RankAvgCurrent: changeArray[index].data[0].value,
	    //	    RankAvgChange1d: pct1dChangeArray[index],
	    //	    RankAvgMinus1wSet: changeArray[index],
	    //	    Rank1Trend1wSet: trendArray[index]
	    
	}
    })
}


const genMockStatementsData = () => {

    // eslint-disable-next-line
    let countsArray = []
    let changeArray = []
    let trendArray = []
    let pct1dChangeArray = []

    let statementArray = [
	// ALL-ALL
	// DACA
	{uuid: "us-fed-stmt-mock-1", txt: "The Dream Act would add over $22B cost to the economy", level: "Federal", issueUUID: "us-fed-mock-daca-all-all", RANK: 1, CHECK_COUNT: 90015},
	{uuid: "us-fed-stmt-mock-2", txt: "Would only encourage more illegal immigration", level: "Federal", issueUUID: "us-fed-mock-daca-all-all",  RANK: 2, CHECK_COUNT: 80200}, // NEXT: start adding those
	{uuid: "us-fed-stmt-mock-3", txt: "Deporting dreamers = inhumane", level: "Federal", issueUUID: "us-fed-mock-daca-all-all", RANK: 3, CHECK_COUNT: 80131},
	{uuid: "us-fed-stmt-mock-4", txt: "Don't give amnesty to law breakers", level: "Federal", issueUUID: "us-fed-mock-daca-all-all", RANK: 4, CHECK_COUNT: 80110},
	{uuid: "us-fed-stmt-mock-5", txt: "We need develop a screening process to admit the qualified", level: "Federal", issueUUID: "us-fed-mock-daca-all-all", RANK: 5, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-6", txt: "They've enriched society", level: "Federal", issueUUID: "us-fed-mock-daca-all-all", RANK: 6, CHECK_COUNT: 70220},
	{uuid: "us-fed-stmt-mock-7", txt: "They didn't make the choice to disobey our immigration laws", level: "Federal", issueUUID: "us-fed-mock-daca-all-all", RANK: 7, CHECK_COUNT: 70105},
	{uuid: "us-fed-stmt-mock-8", txt: "Why aren't dreamers called \"illegal\"?  Calling them \"dreamers\" is just a PR stunt", level: "Federal", issueUUID: "us-fed-mock-daca-all-all", RANK: 8, CHECK_COUNT: 7098},
	// ALL-ALL
	// Charter schools
	// put in the RANK, CHECK_COUNT, CHECK_COUNT_TREND here
	{uuid: "us-fed-stmt-mock-9", txt: "Offers better education in disadvantaged areas", level: "Federal", issueUUID: "us-fed-mock-charter-all-all", RANK: 1, CHECK_COUNT: 90015},
	{uuid: "us-fed-stmt-mock-10", txt: "They drain money from public schools", level: "Federal", issueUUID: "us-fed-mock-charter-all-all", RANK: 2, CHECK_COUNT: 80200},
	{uuid: "us-fed-stmt-mock-11", txt: "Avoids problems of unions;  better teachers want to be there", level: "Federal", issueUUID: "us-fed-mock-charter-all-all", RANK: 3, CHECK_COUNT: 80131},
	{uuid: "us-fed-stmt-mock-12", txt: "They \"cherry pick\" better students from public schools", level: "Federal", issueUUID: "us-fed-mock-charter-all-all", RANK: 4, CHECK_COUNT: 80110},
	{uuid: "us-fed-stmt-mock-13", txt: "Charter schools ARE public schools", level: "Federal", issueUUID: "us-fed-mock-charter-all-all", RANK: 5, CHECK_COUNT: 70200},
	{uuid: "us-fed-stmt-mock-14", txt: "Charter school parents are more involved", level: "Federal", issueUUID: "us-fed-mock-charter-all-all", RANK: 6, CHECK_COUNT: 70104},
	{uuid: "us-fed-stmt-mock-15", txt: "We should work to improve public schools not detract from them", level: "Federal", issueUUID: "us-fed-mock-charter-all-all", RANK: 7, CHECK_COUNT: 70012},
	{uuid: "us-fed-stmt-mock-16", txt: "They can force public schools improve to be competitive", level: "Federal", issueUUID: "us-fed-mock-charter-all-all", RANK: 8, CHECK_COUNT: 70009},


	// CA-ALL
	// DACA
	{uuid: "us-fed-stmt-mock-17", txt: "The Dream Act would add over $22B cost to the economy", level: "Federal", issueUUID: "us-fed-mock-daca-ca-all", RANK: 1, CHECK_COUNT: 90015},
	{uuid: "us-fed-stmt-mock-18", txt: "Would only encourage more illegal immigration", level: "Federal", issueUUID: "us-fed-mock-daca-ca-all",  RANK: 2, CHECK_COUNT: 80200}, // NEXT: start adding those
	{uuid: "us-fed-stmt-mock-19", txt: "Deporting dreamers = inhumane", level: "Federal", issueUUID: "us-fed-mock-daca-ca-all", RANK: 3, CHECK_COUNT: 80131},
	{uuid: "us-fed-stmt-mock-20", txt: "Don't give amnesty to law breakers", level: "Federal", issueUUID: "us-fed-mock-daca-ca-all", RANK: 4, CHECK_COUNT: 80110},
	{uuid: "us-fed-stmt-mock-21", txt: "We need develop a screening process to admit the qualified", level: "Federal", issueUUID: "us-fed-mock-daca-ca-all", RANK: 5, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-22", txt: "They've enriched society", level: "Federal", issueUUID: "us-fed-mock-daca-ca-all", RANK: 6, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-23", txt: "They didn't make the choice to disobey our immigration laws", level: "Federal", issueUUID: "us-fed-mock-daca-ca-all", RANK: 7, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-24", txt: "Why aren't dreamers called \"illegal\"?  Calling them \"dreamers\" is just a PR stunt", level: "Federal", issueUUID: "us-fed-mock-daca-ca-all", RANK: 8, CHECK_COUNT: 70300},

	// CA-ALL
	// Charter schools
	{uuid: "us-fed-stmt-mock-25", txt: "Offers better education in disadvantaged areas", level: "Federal", issueUUID: "us-fed-mock-charter-ca-all", RANK: 1, CHECK_COUNT: 90015},
	{uuid: "us-fed-stmt-mock-26", txt: "They drain money from public schools", level: "Federal", issueUUID: "us-fed-mock-charter-ca-all", RANK: 2, CHECK_COUNT: 80200},
	{uuid: "us-fed-stmt-mock-27", txt: "Avoids problems of unions;  better teachers want to be there", level: "Federal", issueUUID: "us-fed-mock-charter-ca-all", RANK: 3, CHECK_COUNT: 80131},
	{uuid: "us-fed-stmt-mock-28", txt: "They \"cherry pick\" better students from public schools", level: "Federal", issueUUID: "us-fed-mock-charter-ca-all", RANK: 4, CHECK_COUNT: 80110},
	{uuid: "us-fed-stmt-mock-29", txt: "Charter schools ARE public schools", level: "Federal", issueUUID: "us-fed-mock-charter-ca-all", RANK: 5, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-30", txt: "Charter school parents are more involved", level: "Federal", issueUUID: "us-fed-mock-charter-ca-all", RANK: 6, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-31", txt: "We should work to improve public schools not detract from them", level: "Federal", issueUUID: "us-fed-mock-charter-ca-all", RANK: 7, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-32", txt: "They can force public schools improve to be competitive", level: "Federal", issueUUID: "us-fed-mock-charter-ca-all", RANK: 8, CHECK_COUNT: 70300},


	// CA-94010
	// DACA
	{uuid: "us-fed-stmt-mock-17", txt: "The Dream Act would add over $22B cost to the economy", level: "Federal", issueUUID: "us-fed-mock-daca-ca-94010", RANK: 1, CHECK_COUNT: 90015},
	{uuid: "us-fed-stmt-mock-18", txt: "Would only encourage more illegal immigration", level: "Federal", issueUUID: "us-fed-mock-daca-ca-94010",  RANK: 2, CHECK_COUNT: 80200},
	{uuid: "us-fed-stmt-mock-19", txt: "Deporting dreamers = inhumane", level: "Federal", issueUUID: "us-fed-mock-daca-ca-94010", RANK: 3, CHECK_COUNT: 80131},
	{uuid: "us-fed-stmt-mock-20", txt: "Don't give amnesty to law breakers", level: "Federal", issueUUID: "us-fed-mock-daca-ca-94010", RANK: 4, CHECK_COUNT: 80110},
	{uuid: "us-fed-stmt-mock-21", txt: "We need develop a screening process to admit the qualified", level: "Federal", issueUUID: "us-fed-mock-daca-ca-94010", RANK: 5, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-22", txt: "They've enriched society", level: "Federal", issueUUID: "us-fed-mock-daca-ca-94010", RANK: 6, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-23", txt: "They didn't make the choice to disobey our immigration laws", level: "Federal", issueUUID: "us-fed-mock-daca-ca-94010", RANK: 7, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-24", txt: "Why aren't dreamers called \"illegal\"?  Calling them \"dreamers\" is just a PR stunt", level: "Federal", issueUUID: "us-fed-mock-daca-ca-94010", RANK: 8, CHECK_COUNT: 70300},

	// CA-94010
	// Charter schools
	{uuid: "us-fed-stmt-mock-25", txt: "Offers better education in disadvantaged areas", level: "Federal", issueUUID: "us-fed-mock-charter-ca-94010", RANK: 1, CHECK_COUNT: 90015},
	{uuid: "us-fed-stmt-mock-26", txt: "They drain money from public schools", level: "Federal", issueUUID: "us-fed-mock-charter-ca-94010", RANK: 2, CHECK_COUNT: 80200},
	{uuid: "us-fed-stmt-mock-27", txt: "Avoids problems of unions;  better teachers want to be there", level: "Federal", issueUUID: "us-fed-mock-charter-ca-94010", RANK: 3, CHECK_COUNT: 80131},
	{uuid: "us-fed-stmt-mock-28", txt: "They \"cherry pick\" better students from public schools", level: "Federal", issueUUID: "us-fed-mock-charter-ca-94010", RANK: 4, CHECK_COUNT: 80110},
	{uuid: "us-fed-stmt-mock-29", txt: "Charter schools ARE public schools", level: "Federal", issueUUID: "us-fed-mock-charter-ca-94010", RANK: 5, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-30", txt: "Charter school parents are more involved", level: "Federal", issueUUID: "us-fed-mock-charter-ca-94010", RANK: 6, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-31", txt: "We should work to improve public schools not detract from them", level: "Federal", issueUUID: "us-fed-mock-charter-ca-94010", RANK: 7, CHECK_COUNT: 70300},
	{uuid: "us-fed-stmt-mock-32", txt: "They can force public schools improve to be competitive", level: "Federal", issueUUID: "us-fed-mock-charter-ca-94010", RANK: 8, CHECK_COUNT: 70300},
	
	
	// 12345 Atheletes
	{uuid: "us-fed-stmt-mock-120", txt: "Schools are making Billions off their backs; it's time to share", level: "Federal", issueUUID: "us-nd-atheletes-all-12345"},
	{uuid: "us-fed-stmt-mock-121", txt: "There's too much money in sports", level: "Federal", issueUUID: "us-nd-atheletes-all-12345"},
	{uuid: "us-fed-stmt-mock-122", txt: "NCAA has enough trouble with illegal recruiting already", level: "Federal", issueUUID: "us-nd-atheletes-all-12345"},
	{uuid: "us-fed-stmt-mock-123", txt: "Agents will do dirty  uprecruiting - colleges would  buy best agents", level: "Federal", issueUUID: "us-nd-atheletes-all-12345"},
	{uuid: "us-fed-stmt-mock-124", txt: "If athletes can't appreciate an education, they should not go to college", level: "Federal", issueUUID: "us-nd-atheletes-all-12345"},
	{uuid: "us-fed-stmt-mock-125", txt: "Athletes risk injury and lose study time - pay for their sacrifice", level: "Federal", issueUUID: "us-nd-atheletes-all-12345"},
	{uuid: "us-fed-stmt-mock-126", txt: "Many programs lose money - can't afford it", level: "Federal", issueUUID: "us-nd-atheletes-all-12345"},
	{uuid: "us-fed-stmt-mock-127", txt: "Some D-1 schools use the \"profits to benefit the students\" - all of them", level: "Federal", issueUUID: "us-nd-atheletes-all-12345"},
	
    ]

    // eslint-disable-next-line
    countsArray = [
	1000,
	15000,
	30000,
	50000,
	60000,
	35000,
	100000,
	40000,
	10000,
	20000,
	45677,
	54000,
	34000,
	100000,
	40000,
	10000,
	20000,
	45677,
	54000,
	34000,
	45677,
	54000,
	34000,
	100000,
	40000,
	10000,
	20000,
	45677,
    ]


    for(let i = 1; i <= statementArray.length; i++) {
        let startVal = i >= 4 ? (i%4 + 1) : i

        let finVal = i >= 5 ? (i%5 + 1) : i
        
        trendArray.push({
	    name: "Rank Trend (1w)",
	    data: [
                { "date": moment("2019-11-10").toDate(), "value": startVal },
                { "date": moment("2019-11-11").toDate(), "value": 2 },
                { "date": moment("2019-11-12").toDate(), "value": 3 },
                { "date": moment("2019-11-13").toDate(), "value": 3 },
                { "date": moment("2019-11-14").toDate(), "value": 2 },
                { "date": moment("2019-11-15").toDate(), "value": 1 },
                { "date": moment("2019-11-16").toDate(), "value": finVal }
	    ]
        })

        changeArray.push({
	    name: "Rank Change (1w)",
	    data: [
                { "category": "blah", "value": finVal, "priv": startVal },
	    ]
        })

        let pctChange = 0
        let prevVal = 3
        if(finVal < prevVal) {
	    pctChange = (prevVal - finVal) * (1/5) * 100 // 1 of max points
        } else if(finVal > prevVal) {
	    pctChange = -(finVal - prevVal) * (1/5) * 100 // 1 of max point
        }
        
        pct1dChangeArray.push(
	    pctChange
        )
        
    }
    
    return  statementArray.map((issue, index) => {
	// {uuid: "uuid-1", place: 1, name: "Issue 1", counts: 10000, RankAvgCurrent: 1}
	return {
	    issue: {
		uuid: statementArray[index].issueUUID,
		level: statementArray[index].level
	    },
	    txt: statementArray[index].txt,
	    uuid: statementArray[index].uuid,
	    place: index,
	    RANK: statementArray[index].RANK,
	    CHECK_COUNT: statementArray[index].CHECK_COUNT,
	    CHECK_COUNT_TREND: trendArray[index]
	    /*
	    counts: Math.floor(countsArray[index] / issueArray.length),
	    RankAvgCurrent: changeArray[index].data[0].value,
	    RankAvgChange1d: pct1dChangeArray[index],
	    RankAvgMinus1wSet: changeArray[index],
	    Rank1Trend1wSet: trendArray[index]	    
	    */
	}
    })
}

const getIssuesStatsData = (args, callbacks) => {

    log.trace("getIssuesStatsData(): DEMO: START new")
    log.trace("getIssuesStatsData(): DEMO: args =", args)
    log.trace("getIssuesStatsData(): DEMO: callbacks =", callbacks)
    let mocks = genMockIssuesData()
    log.trace("getIssuesStatsData(): DEMO: mocks =", mocks)

    let result = {
	data: {
	    stats: []
	}
    }


    result.data.stats = mocks

    log.trace(`getIssuesStatsData(): DEMO FILTER: (INITIAL): result count = ${result.data.stats.length}`)
    log.trace(`getIssuesStatsData(): DEMO FILTER: (INITIAL): levelCurrent = ${args.levelCurrent}, geoStateCurrent = ${args.geoStateCurrent}, geoZipCurrent = ${args.geoZipCurrent}`)

    //
    // Level filter
    //
    if(args.levelCurrent === "All-Levels") {
	result.data.stats = _.filter(result.data.stats, (el) => {
	    return el.issue.level // level exists, all levels
	})
	log.trace(`getIssuesStatsData(): DEMO FILTER: (Level = ${args.levelCurrent}): result count = ${result.data.stats.length}`)
    } else {
	result.data.stats = _.filter(result.data.stats, (el) => {
	    return el.issue.level === args.levelCurrent
	})
	log.trace(`getIssuesStatsData(): DEMO FILTER: (Level = ${args.levelCurrent}): result count = ${result.data.stats.length}`)
    }

    // next: do the state filter the same way as above

    //
    // State filter
    //
    if(args.geoStateCurrent === "All-States") {
	result.data.stats = _.filter(result.data.stats, (el) => {
	    return el.issue.geoState === "ALL"
	})
	log.trace(`getIssuesStatsData(): DEMO FILTER: (State = ${args.geoStateCurrent}): result count = ${result.data.stats.length}`)
    } else {
	result.data.stats = _.filter(result.data.stats, (el) => {
	    return el.issue.geoState === args.geoStateCurrent
	})
	log.trace(`getIssuesStatsData(): DEMO FILTER: (State = ${args.geoStateCurrent}): result count = ${result.data.stats.length}`)
    }


    //
    // Zip filter
    //
    if(args.geoZipCurrent === "All-Zips" || !args.geoZipCurrent) {
	result.data.stats = _.filter(result.data.stats, (el) => {
	    return el.issue.geoZip === "ALL"
	})
	log.trace(`getIssuesStatsData(): DEMO FILTER: (Zip = ${args.geoZipCurrent}): result count = ${result.data.stats.length}`)
    } else {
	result.data.stats = _.filter(result.data.stats, (el) => {
	    return el.issue.geoZip === args.geoZipCurrent
	})
	log.trace(`getIssuesStatsData(): DEMO FILTER: (Zip = ${args.geoZipCurrent}): result count = ${result.data.stats.length}`)
    }

    
    log.trace("getIssuesStatsData(): DEMO: result =", result)

    callbacks.onResult(result)

    return [] // we should not be here
}


const getStatementsStatsData = (args, callbacks) => {
    log.trace("getStatementsStatsData(): DEMO: START new")
    log.trace("getStatementsStatsData(): DEMO: args =", args)
    log.trace("getStatementsStatsData(): DEMO: callbacks =", callbacks)
    log.trace("getStatementsStatsData(): DEMO: mocks =", genMockStatementsData())

    // NEXT: issues should be coded, like data should be us-fed-daca-1 and then all the statements
    // should be close to that

    let result = {
	data: {
	    stats: []
	}
    }

    result.data.stats = _.filter(genMockStatementsData(), (el) => {
	return el.issue.uuid === args.issueUUID
    })


    log.trace("getStatementsStatsData(): DEMO: result =", result)
    
    // fill out here

    callbacks.onResult(result)
    
    /*
    if(true) {
	return _.filter(genMockStatementsData(), (statement) => {
	    log.trace("getStatementsStatsData(): statement =", statement)
	    return statement.issueUUID === issueUUID
	})
    }
    */

    return []
}



// eslint-disable-next-line
const getIssueStats = (filters = {}, callbacks) => {
    // NEXT: continue here
    log.trace("getIssueStats(): filters =", filters)
    log.trace("getIssueStats(): callbacks =", callbacks)

    return [{some: "blah"}]
}


const getIssueTrends = async (geoLevel, aggLevel, callbacks, filters = {}) => {
    log.debug("getIssueTrends(): SSDDATA: geoLevel =", geoLevel)
    log.debug("getIssueTrends(): SSDDATA: aggLevel =", aggLevel)
    log.trace("getIssueTrends(): SSDDATA: callbacks =", callbacks) 
    log.debug("getIssueTrends(): SSDDATA: filters =", filters)

    const gqlClient = getGqlClient()

    let queryConfig

    let sourceLike

    if(filters.sourceLike) {
	sourceLike = filters.sourceLike
    } else {
	sourceLike = "fback%"
	// sourceLike = "none"
    }
    
    if(geoLevel === "NATIONAL") {
	queryConfig = {
	    //	    query: GetIssueTrendsQuery,
	    query: GET_ISSUE_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike
	    }
	}
    } else if (geoLevel === "STATE") {
	queryConfig = {
	    //	    query: GetIssueTrendsQuery,
	    query: GET_ISSUE_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike,
		stateCode: filters.stateCode,
	    }
	}
    } else if (geoLevel === "SSD") {
	log.debug("getIssueTrends(): SSDDATA: inside SSD")
	queryConfig = {
	    //	    query: GetIssueTrendsQuery,
	    query: GET_ISSUE_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike,
		stateCode: filters.stateCode,
		ssdCode: filters.ssdCode,
	    }
	}
    } else if (geoLevel === "USCD") {
	queryConfig = {
	    //	    query: GetIssueTrendsQuery,
	    query: GET_ISSUE_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike,
		stateCode: filters.stateCode,
		uscdCode: filters.uscdCode,
	    }
	}
    } else if (geoLevel === "ZIP") {
	queryConfig = {
	    query: GET_ISSUE_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike,
		stateCode: filters.stateCode,
//		uscdCode: filters.uscdCode,
		zipCode: filters.zipCode,
	    }
	}
    }

    log.trace(`getIssueTrends(): filters = ${JSON.stringify(filters)}", queryConfig =`, queryConfig)

    try {
	const result = await gqlClient.query(queryConfig)
	if(!result.data.issueTrends) {
	    callbacks.onError(result)
	} else {
	    log.trace(`getIssueTrends(): filters = ${JSON.stringify(filters)}", result =`, result)
	    log.debug(`getIssueTrends(): result.data.issueTrends =`, result.data.issueTrends)

	    let FBACK_COUNT_PRO_KV = {}
	    let key

	    const tempMockTrends = result.data.issueTrends.map(d => {
		key = `${d.issue.uuid}-${d.WEEK_N}`
		if(!FBACK_COUNT_PRO_KV[key]) {
		    // FBACK_COUNT_PRO_KV[key] = d.ISSUE_FBACK_COUNT * 0.5
		    FBACK_COUNT_PRO_KV[key] = d.ISSUE_FBACK_COUNT * (Math.floor((Math.random() * 9) + 0) / 10)
		    log.trace("getIssueTrends(): FBACK_COUNT_PRO_KV blah =", FBACK_COUNT_PRO_KV)
		}

		// NEXT: add actual counts
		return {
		    ...d,
		    //ISSUE_FBACK_PRO_COUNT: FBACK_COUNT_PRO_KV[key],
		    //ISSUE_FBACK_PRO_COUNT: Math.round(d.ISSUE_FBACK_POSITIVE_COUNT / (d.ISSUE_FBACK_POSITIVE_COUNT + d.ISSUE_FBACK_NEGATIVE_COUNT) * 100) / 100,
		    //ISSUE_FBACK_PRO_COUNT: 0,
		    ISSUE_FBACK_POSITIVE_RATIO: Math.round(d.ISSUE_FBACK_POSITIVE_COUNT / (d.ISSUE_FBACK_POSITIVE_COUNT + d.ISSUE_FBACK_NEGATIVE_COUNT) * 100) / 100
		}
	    })

	    const tempMockResult = {
		...result,
		data: {
		    ...result.data,
		    issueTrends: tempMockTrends
		}
	    }
	    // callbacks.onResult(result)
	    //log.trace("getIssueTrends(): tempMockResult =", tempMockResult)
	    //const resultString = JSON.stringify(tempMockResult)
	    //log.trace("getIssueTrends(): resultString =", resultString)
	    //const result = JSON.parse(JSON.stringify(tempMockResult)) // deep copy
	    callbacks.onResult(tempMockResult)
	    //callbacks.onResult(result)	    
	}
    } catch (error) {
	callbacks.onError(error)
    }
}


/*
// eslint-disable-next-line
const getStats_deprecated = async (geoLevel, aggLevel, callbacks, filters = {}) => {
    log.trace("getStats(): geoLevel =", geoLevel)
    log.trace("getStats(): aggLevel =", aggLevel)
    log.trace("getStats(): callbacks =", callbacks)
    log.trace("getStats(): filters =", filters)

    const gqlClient = getGqlClient()

    let queryConfig = {
	query: GetStatsQuery,
	variables: {
	    geoLevel: geoLevel,
	    aggLevel: aggLevel,
	    stateCode: filters.stateCode,
	    uscdCode: filters.uscdCode,
	}
    }

    try {
	const result = await gqlClient.query(queryConfig)
	if(!result.data.stats)
	    callbacks.onError(result)
	else 
	    callbacks.onResult(result)
    } catch (error) {
	callbacks.onError(error)
    }
}


// eslint-disable-next-line
const getStatementStats_deprecated = async (geoLevel, aggLevel, callbacks, filters = {}) => {
    log.trace("getStatementStats(): geoLevel =", geoLevel)
    log.trace("getStatementStats(): aggLevel =", aggLevel)
    log.trace("getStatementStats(): callbacks =", callbacks)
    log.trace("getStatementStats(): filters =", filters)

    const gqlClient = getGqlClient()

    let queryConfig = {
	query: GetStatementStatsQuery,
	variables: {
	    geoLevel: geoLevel,
	    aggLevel: aggLevel
//	    stateCode: filters.stateCode,
//	    uscdCode: filters.uscdCode,
	}
    }

    try {
	const result = await gqlClient.query(queryConfig)
	if(!result.data.statementStats)
	    callbacks.onError(result)
	else 
	    callbacks.onResult(result)
    } catch (error) {
	callbacks.onError(error)
    }
}
*/

const getStatementTrendsV2 = async (timeRange, rollups, filters, callbacks) => {
    log.debug("getStatementTrendsV2(): timeRange =", timeRange)
    log.debug("getStatementTrendsV2(): rollups =", rollups)
    log.debug("getStatementTrendsV2(): filters =", filters)
    log.debug("getStatementTrendsV2(): callbacks =", callbacks)

    const queryConfig = {
	query: GET_STATEMENT_TRENDS_V2_QUERY,
	variables: {
	    timeRange,
	    rollups,
	    filters
	}
    }

    try {
	const result = await getGqlClient().query(queryConfig)
	log.debug("getStatementTrendsV2(): result =", result)

	const addedSentimentTrends = result.data.statementTrendsV2.map(d => {
	    return {
		...d,
		STATEMENT_FBACK_POSITIVE_RATIO: Math.round(d.STATEMENT_FBACK_POSITIVE_COUNT / (d.STATEMENT_FBACK_POSITIVE_COUNT + d.STATEMENT_FBACK_NEGATIVE_COUNT) * 100) / 100
	    }
	})

	const addedSentimentResult = {
	    ...result,
	    data: {
		...result.data,
		statementTrendsV2: addedSentimentTrends
	    }
	}
	
	//callbacks.onResult(result)
	callbacks.onResult(addedSentimentResult)
	
    } catch (error) {
	callbacks.onError(error)
    }
    
}


const getIssueTrendsV2 = async (timeRange, rollups, filters, callbacks) => {
    log.debug("getIssueTrendsV2(): timeRange =", timeRange)
    log.debug("getIssueTrendsV2(): rollups =", rollups)
    log.debug("getIssueTrendsV2(): filters =", filters)
    log.debug("getIssueTrendsV2(): callbacks =", callbacks)

    const queryConfig = {
	query: GET_ISSUE_TRENDS_V2_QUERY,
	variables: {
	    timeRange,
	    rollups,
	    filters
	}
    }

    try {
	const result = await getGqlClient().query(queryConfig)
	log.debug("getIssueTrendsV2(): result =", result)

	const addedIssueTrends = result.data.issueTrendsV2.map(d => {
	    return {
		...d,
		ISSUE_FBACK_POSITIVE_RATIO: Math.round(d.ISSUE_FBACK_POSITIVE_COUNT / (d.ISSUE_FBACK_POSITIVE_COUNT + d.ISSUE_FBACK_NEGATIVE_COUNT) * 100) / 100
	    }
	})


	const addedIssueResult = {
	    ...result,
	    data: {
		...result.data,
		issueTrendsV2: addedIssueTrends
	    }
	}
	
	//callbacks.onResult(result)
	callbacks.onResult(addedIssueResult)

	
    } catch (error) {
	callbacks.onError(error)
    }
    
}


const getStatementTrends = async (geoLevel, aggLevel, callbacks, filters = {}) => {
    log.debug("getStatementTrends(): VIEWFIX: geoLevel =", geoLevel)
    log.debug("getStatementTrends(): VIEWFIX: aggLevel =", aggLevel)
    log.trace("getStatementTrends(): VIEWFIX: callbacks =", callbacks)
    log.debug("getStatementTrends(): VIEWFIX: filters =", filters)

    const gqlClient = getGqlClient()

    log.trace("getStatementTrends(): VIEWFIX: gqlClient =", gqlClient)

    let queryConfig

    let sourceLike

    if(filters.sourceLike) {
	sourceLike = filters.sourceLike
    } else {
	sourceLike = "fback%"
	// sourceLike = "none"
    }
    
    if(geoLevel === "NATIONAL") {
	queryConfig = {
	    // query: GetStatementTrendsQuery,
	    query: GET_STATEMENT_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike
	    }
	}
    } else if (geoLevel === "STATE") {
	queryConfig = {
	    //	    query: GetStatementTrendsQuery,
	    query: GET_STATEMENT_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike,
		stateCode: filters.stateCode,
	    }
	}
    } else if (geoLevel === "SSD") {
	log.debug("getStatementTrends(): SSDDATA: inside SSD")
	queryConfig = {
	    //	    query: GetIssueTrendsQuery,
	    query: GET_STATEMENT_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike,
		stateCode: filters.stateCode,
		ssdCode: filters.ssdCode,
	    }
	}
    } else if (geoLevel === "USCD") {
	queryConfig = {
	    //	    query: GetStatementTrendsQuery,
	    query: GET_STATEMENT_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike,
		stateCode: filters.stateCode,
		uscdCode: filters.uscdCode,
	    }
	}
    } else if (geoLevel === "ZIP") {
	queryConfig = {
	    //	    query: GetStatementTrendsQuery,
	    query: GET_STATEMENT_TRENDS_QUERY,
	    variables: {
		geoLevel: geoLevel,
		aggLevel: aggLevel,
		sourceLike: sourceLike,
		stateCode: filters.uscdCodestateCode,
		uscdCode: filters.uscdCode,
		zipCode: filters.zipCode,
	    }
	}
    }

    try {
	const result = await gqlClient.query(queryConfig)
	log.trace("getStatementTrends(): result =", result)
	if(!result.data.statementTrends) {
	    callbacks.onError(result)
	} else {

	    // let FBACK_COUNT_PRO_KV = {}
	    // let key

	    const tempMockTrends = result.data.statementTrends.map(d => {
		return {
		    ...d,
		    STATEMENT_FBACK_POSITIVE_RATIO: Math.round(d.STATEMENT_FBACK_POSITIVE_COUNT / (d.STATEMENT_FBACK_POSITIVE_COUNT + d.STATEMENT_FBACK_NEGATIVE_COUNT) * 100) / 100
		}
	    })

	    log.trace("getStatementTrends(): tempMockTrends =", tempMockTrends)

	    const tempMockResult = {
		...result,
		data: {
		    ...result.data,
		    statementTrends: tempMockTrends
		}
	    }
	    // callbacks.onResult(result)
	    log.trace("getStatementTrends(): tempMockResult =", tempMockResult)
	    callbacks.onResult(tempMockResult)
	}
    } catch (error) {
	callbacks.onError(error)
    }
}


const getTemplateUUID = (_zipCode, zipPlus4) => {
    log.trace("getTemplateUUID(): _zipCode =", _zipCode)
    log.trace("getTemplateUUID(): zipPlus4 =", zipPlus4)

    const zipCode = `${_zipCode}` // force ito string

    log.trace("getTemplateUUID(): zipCode =", zipCode)
    
    let templateUUID
    switch(zipCode) {
    case "94301":
	templateUUID = "template-new-user-zip-94301"
	break
    case "94010":
	templateUUID = "template-new-user-zip-94010"
	break
    case "94025":
	templateUUID = "template-new-user-zip-94025"
	break
    case "94027":
	templateUUID = "template-new-user-zip-94027"
	break
    case "85132":
	templateUUID = "template-new-user-zip-85132"
	break
    default:
	log.error("getTemplateUUID(): ERROR: could not find template")
	break
    }
    return templateUUID
}



const getGeo = (zipCode, _zipPlus4, _address) => {
    let defaultZipPlus4 = "0000"
    let zipPlus4
    let validPlus4s
    let geo
    switch(zipCode) {
    case "94301": // we don't have data for that yet
	validPlus4s = ["2323"]
	if(_zipPlus4 && validPlus4s.includes(_zipPlus4)) {
	    zipPlus4 = _zipPlus4
	} else {
	    zipPlus4 = defaultZipPlus4
	}
	geo = {
	    zipCode: zipCode,
	    zipPlus4: zipPlus4,
	    stateCode: "CA",
	    uscdCode: "18",
	    // street: "18th Street", this should be coming from UI
	    cityName: "Palo Alto", // maybe
	    countyName: "Santa Clara County", // maybe
	    stateName: "California", // maybe
	    nationCode: "USA", // maybe
	    nationName: "United States Of America", // maybe
	    addressUUID: "mock-address-uuid" // maybe
	}
	break
    case "94010": // we don't have data for that yet
	validPlus4s = ["6446"]
	if(_zipPlus4 && validPlus4s.includes(_zipPlus4)) {
	    zipPlus4 = _zipPlus4
	} else {
	    zipPlus4 = defaultZipPlus4
	}
	geo = {
	    zipCode: zipCode,
	    zipPlus4: zipPlus4,
	    stateCode: "CA",
	    uscdCode: "14",
	    // street: "18th Street", this should be coming from UI
	    cityName: "Hillborough", // maybe
	    countyName: "San Mateo County", // maybe
	    stateName: "California", // maybe
	    nationCode: "USA", // maybe
	    nationName: "United States Of America", // maybe
	    addressUUID: "mock-address-uuid" // maybe
	}
	break
    case "94025":
	validPlus4s = ["4224"]
	if(_zipPlus4 && validPlus4s.includes(_zipPlus4)) {
	    zipPlus4 = _zipPlus4
	} else {
	    zipPlus4 = defaultZipPlus4
	}
	geo = {
	    zipCode: zipCode,
	    zipPlus4: zipPlus4,
	    stateCode: "CA",
	    uscdCode: "18",
	    // street: "18th Street", this should be coming from UI
	    cityName: "Menlo Park", // maybe
	    countyName: "San Mateo County", // maybe
	    stateName: "California", // maybe
	    nationCode: "USA", // maybe
	    nationName: "United States Of America", // maybe
	    addressUUID: "mock-address-uuid" // maybe
	}
	break
    case "94027":
	validPlus4s = ["3942"]
	if(_zipPlus4 && validPlus4s.includes(_zipPlus4)) {
	    zipPlus4 = _zipPlus4
	} else {
	    zipPlus4 = defaultZipPlus4
	}
	geo = {
	    zipCode: zipCode,
	    zipPlus4: zipPlus4,
	    stateCode: "CA",
	    uscdCode: "18",
	    // street: "18th Street", this should be coming from UI
	    cityName: "Atherton", // maybe
	    countyName: "San Mateo County", // maybe
	    stateName: "California", // maybe
	    nationCode: "USA", // maybe
	    nationName: "United States Of America", // maybe
	    addressUUID: "mock-address-uuid" // maybe
	}
	break
    case "85132":
	validPlus4s = ["3942"]
	if(_zipPlus4 && validPlus4s.includes(_zipPlus4)) {
	    zipPlus4 = _zipPlus4
	} else {
	    zipPlus4 = defaultZipPlus4
	}
	geo = {
	    zipCode: zipCode,
	    zipPlus4: zipPlus4,
	    stateCode: "AZ",
	    uscdCode: "04",
	    // street: "18th Street", this should be coming from UI
	    cityName: "Florence", // maybe
	    countyName: "Pinal County", // maybe
	    stateName: "Arizona", // maybe
	    nationCode: "USA", // maybe
	    nationName: "United States Of America", // maybe
	    addressUUID: "mock-address--az-uuid" // maybe
	}
	break
    default:
	log.error("getGeo(): ERROR: could not map zip")
	break
    } // end of switch
    return geo
}

const makeNewSlug = (user) => {
    const email = user.email

    let newSlug = user.email.replace('@', "-at-")
    newSlug = newSlug.replace(".", "-")
    newSlug += "-slug"
    return newSlug
}

const getInitUser = async (user) => {
    const gqlClient = getGqlClient()

    const userEmail = `init.user.${user.geo.address.zip.code}@lightning.live`

    const readUserDataConfig = {
	query: READ_USER_DATA_QUERY,
        variables: {
	    userEmail: userEmail
        }
    }

    try {
	const result = await gqlClient.query(readUserDataConfig)
	log.debug("getInitUser(): AWAIT: result =", result)

	if(!result.data.user) { // might need it at some point
	    return undefined
	} else {
	    return result.data.user
	}
    } catch (error) {
	return undefined
    }
}

const quickRegisterNewUser = async (user, callbacks) => {
    log.debug("quickRegisterNewUser(): vaporURL =", getVaporURL())
    log.debug("quickRegisterNewUser(): user =", user)

    const newUserSlug = makeNewSlug(user)
    user.slug = newUserSlug

    // First we need to get an init user so that we can get all the attributes from it

    const initUser = await getInitUser(user)
    log.debug("quickRegisterNewUser(): initUser =", initUser)
    if(!initUser) return // we got a wrong zip or something else

    //    const singleStatements = initUser.statements.filter(statement => {
    //	return statement.slug === 'california-high-spped-rail-sd13-issue-f88726'
    //    })

    initUser.statements.forEach(statement => {
	log.debug("quickRegisterNewUser(): 1: statement.slug =", statement.slug)
	log.debug("quickRegisterNewUser(): 1: statement.drive.slug =", statement.drive.slug)
    })

    if(!initUser) {
	callbacks.onError("no InitUser")
	return
    }

    log.debug("quickRegisterNewUser(): user =", user)

    const mergedUser = {
	slug: user.slug,
	name: user.name,
	email: user.email,
	geo: jsonDeleteKeys(initUser.geo,["__typename"]),
	isActive: true,
	isVerified: true,
	loginLevel: "UNVERIFIED"
    }
    mergedUser.geo.address.street = user.geo.address.street
    
    log.debug("quickRegisterNewUser(): mergedUser =", mergedUser)

    //
    // NEW SET USER
    //
    const variables = {
	"user": mergedUser
    }
    
    log.debug("quickRegisterNewUser(): variables =", variables)

    const saveUserMutationConfig = {
	mutation: SAVE_USER_MUTATION,
	variables: variables
    }

    //log.debug("quickRegisterNewUser(): singleStatements =", singleStatements)

    const gqlClient = getGqlClient()

    const saveUserResult = await gqlClient.mutate(saveUserMutationConfig)

    log.debug("quickRegisterNewUser(): saveUserResult =", saveUserResult)

    const savedUser = saveUserResult.data.saveUser

    log.debug("quickRegisterNewUser(): savedUser =", savedUser)

    try {
	const copyUserPostsResult = await gqlClient.mutate({
	    mutation: COPY_USER_POSTS_MUTATION,
	    variables: {
		fromUser: jsonDeleteKeys(initUser,["__typename", "statements", "contacts"]),
		toUser: jsonDeleteKeys(savedUser,["__typename", "statements", "contacts"])
	    }
	})

	log.debug("quickRegisterNewUser(): copyUserPostsResult =", copyUserPostsResult)
	if(!copyUserPostsResult.data
	   || !copyUserPostsResult.data.copyUserPosts
	   || copyUserPostsResult.data.copyUserPosts.length === 0) {
	    callbacks.onError(`No statements copied, copying to savedUser.slug = ${savedUser.slug} from ${initUser.slug}`)
	} else {
	    callbacks.onResult(savedUser)
	}
	
    } catch (error) {
	//callbacks.onError(`Caught error during the call, copying to savedUser.slug = ${savedUser.slug} from ${initUser.slug}`)
	// don't to explicity user here because we're registered, just could not copy
	log.debug("quickRegisterNewUser(): WARNING: copyUserPostsResult did not work, skip do not error out")
	callbacks.onResult(savedUser)
    }
    
}

const quickRegisterNewUser_old_last = async (user, callbacks) => {
    log.debug("quickRegisterNewUser(): vaporURL =", getVaporURL())
    log.debug("quickRegisterNewUser(): user =", user)

    const newUserSlug = makeNewSlug(user)
    user.slug = newUserSlug

    // First we need to get an init user so that we can get all the attributes from it

    const initUser = await getInitUser(user)
    log.debug("quickRegisterNewUser(): initUser =", initUser)
    
    if(!initUser) {
	callbacks.onError("no InitUser")
	return
    }

    log.debug("quickRegisterNewUser(): user =", user)

    const mergedUser = {
	slug: user.slug,
	name: user.name,
	email: user.email,
	geo: jsonDeleteKeys(initUser.geo,["__typename"]),
	isActive: true,
	isVerified: true,
	loginLevel: "UNVERIFIED"
    }
    mergedUser.geo.address.street = user.geo.address.street
    
    log.debug("quickRegisterNewUser(): mergedUser =", mergedUser)

    //
    // NEW SET USER
    //
    const variables = {
	"user": mergedUser
    }
    
    log.debug("quickRegisterNewUser(): variables =", variables)

    const saveUserMutationConfig = {
	mutation: SAVE_USER_MUTATION,
	variables: variables
    }

    const gqlClient = getGqlClient()

    const saveUserResult = await gqlClient.mutate(saveUserMutationConfig)

    log.debug("quickRegisterNewUser(): saveUserResult =", saveUserResult)

    const savedUser = saveUserResult.data.saveUser
   
    try {
	const copyUserPostsResult = await gqlClient.mutate({
	    mutation: COPY_USER_POSTS_MUTATION,
	    variables: {
		fromUser: jsonDeleteKeys(initUser,["__typename", "statements", "contacts"]),
		toUser: jsonDeleteKeys(savedUser,["__typename", "statements", "contacts"])
	    }
	})

	log.debug("quickRegisterNewUser(): copyUserPostsResult =", copyUserPostsResult)
	if(!copyUserPostsResult.data
	   || !copyUserPostsResult.data.copyUserPosts
	   || copyUserPostsResult.data.copyUserPosts.length === 0) {
	    callbacks.onError(`No statements copied, copying to savedUser.slug = ${savedUser.slug} from ${initUser.slug}`)
	} else {
	    callbacks.onResult(savedUser)
	}
	
    } catch (error) {
	//callbacks.onError(`Caught error during the call, copying to savedUser.slug = ${savedUser.slug} from ${initUser.slug}`)
	// don't to explicity user here because we're registered, just could not copy
	log.debug("quickRegisterNewUser(): WARNING: copyUserPostsResult did not work, skip do not error out")
	callbacks.onResult(savedUser)
    }
}


const validateGeo = async (geo) => {
    console.log("validateGeo(): GETGEOS: geo =", geo)

    const retObj = {isValid: false}

    const validGeos = await getValidGeos({
	level: "STATE",
	stateCode: "CA"
    }, { level: "ZIP"})

    console.log("validateGeo(): GETGEOS: validGeos =", validGeos)

    const validZipCodes = validGeos.map(user => user.geo.address.zip.code)
    console.log("validateGeo(): GETGEOS: validZipCodes =", validZipCodes)

    const foundZipCode = validZipCodes.find(code => code === geo.address.zip.code)

    if(foundZipCode) {
	retObj.isValid = true
    }
    
    /*
    const validZips = [
	// SSD 13
	94010
	,94025
	// SSD 15
	,95110]
    */

    /*
    const validZips = [...dist13ZipCodes, ...dist15ZipCodes]

    const validGeos = {
	zips: validZips.map(zipCode => ({code: ""+ zipCode, plus4: "0000"}))
    }

    const find = validGeos.zips.find(zip => zip.code === geo.address.zip.code)
    console.log("validateGeo(): find =", find)


    // validate
    if(validGeos.zips.find(zip => zip.code === geo.address.zip.code)) {
	retObj.isValid = true
	console.log("validateGeo(): geo is valid")
    }

    retObj.validGeos = validGeos
    */
    
    return retObj
}


const quickRegisterNewUser_old = async (user, callbacks) => {
    log.trace("quickRegisterNewUser(): vaporURL =", getVaporURL())
    log.trace("quickRegisterNewUser(): user =", user)
    
    const templateUUID = getTemplateUUID(user.geo.address.zip.code, user.geo.address.zip.plus4)
    log.trace("quickRegisterNewUser(): matched templateUUID =", templateUUID)

    const geo = getGeo(user.geo.address.zip.code,
		       user.geo.address.zip.plus4, // zipPlus4
		       undefined) // address

    log.trace("quickRegisterNewUser(): got geo =", geo)

    const userToRegister = {
	...user,
	isActive: true,
	isVerified: true,
	loginLevel: "VERIFIED",
	"geo": {
	    "city":{
		"name": geo.cityName
	    },
	    "county": {
		"name": geo.countyName
	    },
	    "state": {
		"code": geo.stateCode,
		"name": geo.stateName
	    },
	    "uscd": {
		"code": geo.uscdCode
	    },
	    "nation": {
		"code": geo.nationCode,
		"name": geo.nationName
	    },
	    "address": {
		...user.geo.address,
		"uuid": geo.addressUUID,
		"zip": {
		    "code": geo.zipCode,
		    "plus4": geo.zipPlus4
		}
	    }
	}
    }

    log.trace("quickRegisterNewUser(): constructed userToRegister =", userToRegister)
    log.trace("quickRegisterNewUser(): constructed user =", user)

    //
    // SET USER
    //
    
    const variables = {
	"user": userToRegister
    }
    
    log.trace("quickRegisterNewUser(): variables =", variables)

    const setUserMutationConfig = {
	mutation: SET_USER_MUTATION,
	variables: variables
    }

    const gqlClient = getGqlClient()

    const setUserResult = await gqlClient.mutate(setUserMutationConfig)
    log.trace("quickRegisterNewUser(): setUserResult = ", setUserResult)
    log.trace("quickRegisterNewUser(): setUserResult.data = ", setUserResult.data)
    log.trace("quickRegisterNewUser(): setUserResult.data.setUser = ", setUserResult.data.setUser)
    log.trace("quickRegisterNewUser(): setUserResult.data.setUser.data = ", setUserResult.data.setUser)

    const registeredUser = flat.unflatten(JSON.parse(setUserResult.data.setUser).data[0]).user
    log.trace("quickRegisterNewUser(): registeredUser = ", registeredUser)

    const setUserResponse = JSON.parse(setUserResult.data.setUser)
    log.trace("quickRegisterNewUser(): setUserResponse = ", setUserResponse)

    //
    // WRITE POSTS
    //

    const writePostsVariables = {
	"userUUID": userToRegister.uuid,
	"templateUUID": templateUUID
    }
    
    const writePostsMutationConfig = {
	mutation: WRITE_POSTS_MUTATION,
	variables: writePostsVariables
    }

    const writePostsResult = await gqlClient.mutate(writePostsMutationConfig)
    log.trace("quickRegisterNewUser(): writePostsResult = ", writePostsResult)


    if(writePostsResult
       && !writePostsResult.errors
       && writePostsResult.data
       && writePostsResult.data.writePosts !== null
       && writePostsResult.data.writePosts !==""
      ) {
	callbacks.onResult(registeredUser)
    } else  {
	callbacks.onError(writePostsResult)
    }
    
}

const convertFlashToBackendGeo = _geo => {
    const geo = {
	level: undefined,
	nation: undefined,
	uscd: { code: undefined },
	ssd: { code: undefined },
	address: {
	    state: {
		code: undefined
	    },
	    zip: {
		code: undefined,
		plus4: undefined
	    }
	}
    }

    //geo.address.state.code = "CA blah"


    if(!geo) return undefined

    geo.level = _geo.level
    geo.address.state.code = _geo.stateCode
    geo.uscd.code = _geo.uscdCode
    geo.ssd.code = _geo.ssdCode
    geo.address.zip.code = _geo.zipCode
    geo.address.zip.plus4 = _geo.zipPlus4

    return jsonDeleteValues(geo, [undefined])
}

const getValidGeos = async (_geo, _subgeo) => {
    log.debug("getValidGeos(): GETGEOS: _geo = ", _geo)
    log.debug("getValidGeos(): GETGEOS: _subgeo = ", _subgeo)

    let retGeos = []

    const geo = convertFlashToBackendGeo(_geo) // top level setup geo, tells us which level 
    const subgeo = convertFlashToBackendGeo(_subgeo) // return geos at this level
    
    log.debug("getValidGeos(): GETGEOS: geo = ", geo)
    log.debug("getValidGeos(): GETGEOS: subgeo = ", subgeo)
    
    let queryConfig = {
	//        query: ReadUserDataQuery,
	query: GET_VALID_GEOS_QUERY,
        variables: {
	    filters:  {
		geo, // top level geo, in first case it will be leve = state and state.code = "CA"
		subgeo
	    }
        }
    }

    const gqlClient = getGqlClient()

    try {
	const result = await gqlClient.query(queryConfig)
	log.debug("getValidGeos(): GETGEOS: result = ", result)
	retGeos = result.data.validGeos
    } catch (error) {
	log.error("getValidGeos(): GETGEOS: error = ", error)
	return undefined
    }
    
    return retGeos
}

const getSubGeos = async (_geo, _subgeo) => {
    log.debug("getSubGeos(): GETGEOS: _geo = ", _geo)
    log.debug("getSubGeos(): GETGEOS: _subgeo = ", _subgeo)

    let retGeos = []

    const geo = convertFlashToBackendGeo(_geo) // top level setup geo, tells us which level 
    const subgeo = convertFlashToBackendGeo(_subgeo) // return geos at this level
    
    log.debug("getSubGeos(): GETGEOS: geo = ", geo)
    log.debug("getSubGeos(): GETGEOS: subgeo = ", subgeo)
    
    let queryConfig = {
	//        query: ReadUserDataQuery,
	query: GET_SUB_GEOS_QUERY,
        variables: {
	    filters:  {
		geo, // top level geo, in first case it will be leve = state and state.code = "CA"
		subgeo
	    }
        }
    }

    const gqlClient = getGqlClient()

    try {
	const result = await gqlClient.query(queryConfig)
	log.debug("getSubGeos(): GETGEOS: result = ", result)
	retGeos = result.data.subGeos
    } catch (error) {
	log.error("getSubGeos(): GETGEOS: error = ", error)
	return undefined
    }
    
    return retGeos
}


const getSubGeoCodes = async geo => {
    log.debug("getSubGeoCodes(): GETGEOS: geo = ", geo)

/*
    const validGeos = await getValidGeos(
	{ level: "STATE", stateCode: "CA"},
	{level: "ZIP"})

    // here great getValidSubgeos with geo as level stateCode "CA" and subgeo as level ZIP
    // getSubGeos should be returning a GEO ano USER as li ValidGeos
    
    log.debug("getSubGeoCodes(): GETGEOS: validGeos = ", validGeos)

    const subGeos = await getSubGeos(
	{ level: "SSD", stateCode: "CA"},
	{level: "ZIP"})

    log.debug("getSubGeoCodes(): GETGEOS: subGeos = ", subGeos)
*/
    
    let subGeoCodes
    if(geo.level === "STATE") { // this is next for the check
	/*
        if(geo.stateCode === "CA") {
            subGeoCodes = ["14", "18", "19"]
        } else if(geo.stateCode === "AZ") {
            subGeoCodes = ["01", "02"]
        } else {
            subGeoCodes = ["0"] // unknown
        }
	*/
	const subGeos = await getSubGeos(
	    { level: geo.level, stateCode: geo.stateCode},
	    {level: "USCD"})
	subGeoCodes = subGeos.map(geo => geo.uscd.code)
	log.debug("getSubGeoCodes(): GETGEOS: subGeoCodes = ", subGeoCodes)

    } else if(geo.level === "SSD") {
	/*
        if(geo.stateCode === "CA") {
            subGeoCodes = [...dist13ZipCodes, ...dist15ZipCodes]
        } else {
            subGeoCodes = ["0"] // unknown
        }
	*/
	const subGeos = await getSubGeos(
	    { level: geo.level, stateCode: geo.stateCode},
	    {level: "ZIP"})

	subGeoCodes = subGeos.map(geo => geo.address.zip.code)

	log.debug("getSubGeoCodes(): GETGEOS: subGeoCodes = ", subGeoCodes)
	
    } else if(geo.level === "USCD") { // our level is USCD, so sub-geo codes are ZIP
	const subGeos = await getSubGeos(
	    { level: geo.level, stateCode: geo.stateCode, uscdCode: geo.uscdCode},
	    {level: "ZIP"})
	log.debug("getSubGeoCodes(): GETGEOS: subGeos = ", subGeos)
	if(subGeos) {
	    subGeoCodes = subGeos.map(geo => geo.address.zip.code)
	}
	log.debug("getSubGeoCodes(): GETGEOS: subGeoCodes = ", subGeoCodes)

	/*
        if(geo.stateCode === "CA") {
            if(geo.uscdCode === "14") {
                subGeoCodes = ["94010", "94025"]
            } else if(geo.uscdCode === "18") {
                subGeoCodes = ["94025"]
            } else if(geo.uscdCode === "19") {
                subGeoCodes = ["95110"]
	    }
        } else if(geo.stateCode === "AZ") {
            if(geo.uscdCode === "01") {
                subGeoCodes = ["85534"]
            } else if(geo.uscdCode === "02") {
                subGeoCodes = ["85605"]
            }
        }
	*/
    } else if(geo.level === "NATIONAL") { // our level is USCD, so sub-geo codes are ZIP
        //subGeoCodes = ["CA", "AZ", "NY"]
        // subGeoCodes = ["CA"]
	const subGeos = await getSubGeos(
	    { level: geo.level},
	    {level: "STATE"})
	subGeoCodes = subGeos.map(geo => geo.address.state.code)
	log.debug("getSubGeoCodes(): GETGEOS: subGeos = ", subGeos)
	log.debug("getSubGeoCodes(): GETGEOS: subGeoCodes = ", subGeoCodes)
    }

    log.debug("getSubGeoCodes(): STICKYFIX: returning subGeoCodes = ", subGeoCodes)
    
    return subGeoCodes
}

// this is to cut off the dataset based on weeks 'cause its the same everywhere
const tailDataset = (inputDataset, tailWeekCount) => {
    let inputFirstWeekNumber
    let inputLastWeekNumber
    let inputDataCount

    // we're doing this at first over the whole dataset
    inputDataset.forEach(d => {
	
	if(!inputFirstWeekNumber) {
	    inputFirstWeekNumber = d["WEEK_N"]
	} else if(d["WEEK_N"] < inputFirstWeekNumber) {
	    inputFirstWeekNumber = d["WEEK_N"]
	}
	
	if(!inputLastWeekNumber) {
	    inputLastWeekNumber = d["WEEK_N"]
	} else if(d["WEEK_N"] > inputLastWeekNumber) {
	    inputLastWeekNumber = d["WEEK_N"]
	}
	
	if(!inputDataCount) {
	    inputDataCount = 1
	} else {
	    inputDataCount++
	}
	
    })

    const cutoffWeekNumber = inputLastWeekNumber - tailWeekCount + 1 // we're including the week that's cutoff
    
    log.trace("tailDataset(): inputFirstWeekNumber = ", inputFirstWeekNumber)
    log.trace("tailDataset(): inputLastWeekNumber = ", inputLastWeekNumber)
    log.trace("tailDataset(): cutoffWeekNumber = ", cutoffWeekNumber)

    const tailDataset = inputDataset.filter(d => {
	log.trace("tailDataset(): d = ", d)
	if(d["WEEK_N"] >= cutoffWeekNumber) {
	    return true
	} else {
	    return false
	}
    }).sort((a,b) => {
        return a["WEEK_N"] - b["WEEK_N"]
    })

    return {
	inputFirstWeekNumber,
	inputLastWeekNumber,
	inputDataCount,
	cutoffWeekNumber,
	tailDataset
    }
    
}

// gets the tail of the number of tailWeekCount
const calcIssueMapDatasetTail = (inputDataset, tailWeekCount) => {
    log.trace("calcIssueMapDatasetTail(): tailWeekCount =", tailWeekCount)

    let {
	inputFirstWeekNumber,
	inputLastWeekNumber,
	inputDataCount,
	cutoffWeekNumber,
	tailDataset: resultDataset
    } = tailDataset(inputDataset, tailWeekCount)
    
    log.trace("calcIssueMapDatasetTail(): inputFirstWeekNumber = ", inputFirstWeekNumber)
    log.trace("calcIssueMapDatasetTail(): inputLastWeekNumber = ", inputLastWeekNumber)
    log.trace("calcIssueMapDatasetTail(): inputDataCount = ", inputDataCount)
    log.trace("calcIssueMapDatasetTail(): cutofFWeekNumber = ", cutoffWeekNumber)
    
    // we're doing this separately in 2 loops for now,
    // because there will probably be more metrics
    // calc metrics
    let resultIssueFbackCount
    let resultFirstWeekNumber
    let resultLastWeekNumber
    let resultDistinctWeeks
    resultDataset.forEach(d => {

	if(!resultDistinctWeeks) {
	    resultDistinctWeeks = [d["WEEK_N"]]
	} else if(!resultDistinctWeeks.includes(d["WEEK_N"])) {
	    resultDistinctWeeks.push(d["WEEK_N"])
	}
	
	if(!resultIssueFbackCount) {
	    resultIssueFbackCount = d.ISSUE_FBACK_COUNT
	} else {
            resultIssueFbackCount += d.ISSUE_FBACK_COUNT
	}

	if(!resultFirstWeekNumber) {
	    resultFirstWeekNumber = d["WEEK_N"]
	} else if(d["WEEK_N"] < inputFirstWeekNumber) {
	    inputFirstWeekNumber = d["WEEK_N"]
	}

	if(!resultLastWeekNumber) {
	    resultLastWeekNumber = d["WEEK_N"]
	} else if(d["WEEK_N"] > resultLastWeekNumber) {
	    resultLastWeekNumber = d["WEEK_N"]
	}
	
    })

    return {
	inputDataset: inputDataset,
	inputDataCount: inputDataCount,
	resultDataset: resultDataset,
	resultDataCount: resultDataset.length,
	inputFirstWeekNumber: inputFirstWeekNumber,
	inputLastWeekNumber: inputLastWeekNumber,
	cutoffWeekNumber: cutoffWeekNumber,
	resultIssueFbackCount: resultIssueFbackCount,
	resultFirstWeekNumber: resultFirstWeekNumber,
	resultLastWeekNumber: resultLastWeekNumber,
	resultDistinctWeeks: resultDistinctWeeks,
	resultDistinctWeeksCount: resultDistinctWeeks ? resultDistinctWeeks.length : undefined,
    }
}


const weighRanksByFbackCounts = (calcs) => {
    const newCalcs = calcs

    const data = calcs.resultDataset
    
    log.debug("weighRanksByFbackCounts(): calcs =", calcs)
    log.debug("weighRanksByFbackCounts(): data =", data)

    const countSum = data.reduce((acc, curr) => {
	return acc + curr.AGG_ISSUE_FBACK_COUNT
    }, 0)

    log.debug("weighRanksByFbackCounts(): countSum =", countSum)

    const dataWithCoeff = data.map(d => {
	return {...d, coeff: d.AGG_ISSUE_FBACK_COUNT / countSum}
    })

    log.debug("weighRanksByFbackCounts(): dataWithCoeff =", dataWithCoeff)

    const dataNewRank = dataWithCoeff.map(d => {
	return {...d, newRank: d.AGG_ISSUE_FBACK_RANK_AVG / d.coeff}
    })

    log.debug("weighRanksByFbackCounts(): dataNewRank =", dataNewRank)
    
    const sortedData = JSON.parse(JSON.stringify(dataNewRank))
	  .sort((a,b) =>{
	      if(a.newRank < b.newRank) return -1
	      return 1
	  })

    let normRank = 0
    let prevNewRank = 0
    const normRankData = sortedData.map(d => {
	if(d.newRank !== prevNewRank) {
	    normRank++
	    prevNewRank = d.newRank
	}
	return {
	    ...d,
	    normRank
	}
    })

    newCalcs.resultDataset = normRankData.map(d => {
	return {
	    ...d,
	    AGG_ISSUE_FBACK_RANK_AVG: d.normRank
	}
    })
    
    return newCalcs
}

const calcIssueTableDatasetTail = (inputDataset, tailWeekCount) => {
    log.trace("calcIssueTableDatasetTail(): tailWeekCount =", tailWeekCount)

    let {
	inputFirstWeekNumber,
	inputLastWeekNumber,
	inputDataCount,
	cutoffWeekNumber,
	tailDataset: resultDataset
    } = tailDataset(inputDataset, tailWeekCount)

    
    // we're doing this separately in 2 loops for now,
    // because there will probably be more metrics
    // calc metrics
    let resultIssueFbackCount
    let resultFirstWeekNumber
    let resultLastWeekNumber
    let resultDistinctWeeks
    resultDataset.forEach(d => {

	if(!resultDistinctWeeks) {
	    resultDistinctWeeks = [d["WEEK_N"]]
	} else if(!resultDistinctWeeks.includes(d["WEEK_N"])) {
	    resultDistinctWeeks.push(d["WEEK_N"])
	}
	
	if(!resultIssueFbackCount) {
	    resultIssueFbackCount = d.ISSUE_FBACK_COUNT
	} else {
            resultIssueFbackCount += d.ISSUE_FBACK_COUNT
	}

	if(!resultFirstWeekNumber) {
	    resultFirstWeekNumber = d["WEEK_N"]
	} else if(d["WEEK_N"] < inputFirstWeekNumber) {
	    inputFirstWeekNumber = d["WEEK_N"]
	}

	if(!resultLastWeekNumber) {
	    resultLastWeekNumber = d["WEEK_N"]
	} else if(d["WEEK_N"] > resultLastWeekNumber) {
	    resultLastWeekNumber = d["WEEK_N"]
	}
	
    })


    // we've got the right dates, now cycle through
    // each elemnets and create a sum
    // we need to have a separate dataset
    // here for grouping
    const aggDataset = []

    // Grouping evertthing by issue and other attributes
    resultDataset.forEach(d => {
	
	log.trace("calcIssueTableDatasetTail(): d =", d)
	log.trace("calcIssueTableDatasetTail(): d.issue.uuid =", d.issue.uuid)
	log.trace("calcIssueTableDatasetTail(): d.issue.slug =", d.issue.slug)

	let foundItem
	aggDataset.forEach(i => {
	    log.trace("calcIssueTableDatasetTail(): i =", i)
	    if(i.issue.uuid === d.issue.uuid) {
		foundItem = i
	    }
	})

	if(!foundItem) {
	    foundItem =  {
		issue: { 
		    uuid: d.issue.uuid,
		    slug: d.issue.slug,
		    txt: d.issue.txt,
		    level: d.issue.level
		},
		LEVELS: d.LEVELS
	    }

	    foundItem.AGG_DATA_COUNT = 0
	    foundItem.AGG_ISSUE_FBACK_COUNT = 0
	    foundItem.AGG_ISSUE_FBACK_LAST_WEEK_COUNT = 0
	    foundItem.AGG_ISSUE_FBACK_RANK_AVG = 0
	    foundItem.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG = 0
	    aggDataset.push(foundItem)
	}

	foundItem.AGG_DATA_COUNT++
	foundItem.AGG_ISSUE_FBACK_LAST_WEEK_COUNT = foundItem.AGG_ISSUE_FBACK_COUNT // last/prev week
	foundItem.AGG_ISSUE_FBACK_COUNT += d.ISSUE_FBACK_COUNT
	// foundItem.AGG_ISSUE_FBACK_PRO_COUNT = foundItem.AGG_ISSUE_FBACK_COUNT / 2
	//foundItem.AGG_ISSUE_FBACK_PRO_COUNT = Math.floor((Math.random() * foundItem.AGG_ISSUE_FBACK_COUNT) + 0)
	//foundItem.AGG_ISSUE_FBACK_POSTIVE_RATIO = d.ISSUE_FBACK_POSITIVE_RATIO
	log.trace("calcIssueTableDatasetTail():  foundItem.AGG_DATA_COUNT = ", foundItem.AGG_DATA_COUNT)
	log.trace("calcIssueTableDatasetTail():  d.ISSUE_FBACK_POSITIVE_RATIO = ", d.ISSUE_FBACK_POSITIVE_RATIO)
	foundItem.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG = ((foundItem.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG * (foundItem.AGG_DATA_COUNT - 1)) + d.ISSUE_FBACK_POSITIVE_RATIO) / foundItem.AGG_DATA_COUNT
	log.trace("calcIssueTableDatasetTail():  foundItem.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG = ", foundItem.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG)

	//foundItem.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG = 0.5

	foundItem.AGG_ISSUE_FBACK_RANK_AVG = ((foundItem.AGG_ISSUE_FBACK_RANK_AVG * (foundItem.AGG_DATA_COUNT - 1)) + d.ISSUE_FBACK_RANK) / foundItem.AGG_DATA_COUNT

	// weight the average so that it takes into the account the overall number of users
	//foundItem.AGG_ISSUE_FBACK_RANK_AVG
	
	//foundItem.AGG_ISSUE_FBACK_RANK_AVG = 10
	
	
    })

    aggDataset.sort((a,b) => {
        return a["AGG_ISSUE_FBACK_RANK_AVG"] - b["AGG_ISSUE_FBACK_RANK_AVG"]
    })
    
    
    return {
	inputDataset: inputDataset,
	inputDataCount: inputDataCount,
	resultDataset: aggDataset,
	resultDataCount: aggDataset.length,
	inputFirstWeekNumber: inputFirstWeekNumber,
	inputLastWeekNumber: inputLastWeekNumber,
	cutoffWeekNumber: cutoffWeekNumber,
	resultIssueFbackCount: resultIssueFbackCount,
	resultFirstWeekNumber: resultFirstWeekNumber,
	resultLastWeekNumber: resultLastWeekNumber,
	resultDistinctWeeks: resultDistinctWeeks,
	resultDistinctWeeksCount: resultDistinctWeeks ? resultDistinctWeeks.length : undefined,
    }
}

const calcStatementTableDatasetTailV2 = (inputDataset, tailWeekCount) => {
    log.debug("calcStatementTableDatasetTailV2(): V2: inputDataset =", inputDataset)
    log.debug("calcStatementTableDatasetTailV2(): V2: tailWeekCount =", tailWeekCount)
    // log.trace("calcStatementTableDatasetTail(): this.state.issue.uuid =", this.state.issue.uuid)
    log.trace("calcStatementTableDatasetTailV2(): again1")

    const {
	inputFirstWeekNumber,
	inputLastWeekNumber,
	inputDataCount,
	cutoffWeekNumber,
//	tailDataset: resultDataset
    } = tailDataset(inputDataset, tailWeekCount)

    log.trace("calcStatementTableDatasetTailV2(): again2")
    
    const aggDataset = []

    inputDataset.forEach(d => {
	let foundItem

	log.trace("calcStatementTableDatasetTailV2(): d = ", d)
	
	aggDataset.forEach(i => {
	    if(i.issue.slug === d.issue.slug
		&& i.statement.slug === d.statement.slug) {
		foundItem = i
	    }
	})

	if(!foundItem) {
	    foundItem =  {
		issue: { 
		    uuid: d.issue.uuid,
		    slug: d.issue.slug,
		    txt: d.issue.txt,
		    level: d.issue.level
		},
		statement: {
		    uuid: d.statement.uuid,
		    slug: d.statement.slug,
		    txt: d.statement.txt,
		},
		
		LEVELS: d.LEVELS
	    }

	    foundItem.AGG_DATA_COUNT = 0
	    foundItem.AGG_STATEMENT_FBACK_COUNT = 0
	    foundItem.AGG_STATEMENT_FBACK_LAST_WEEK_COUNT = 0
	    foundItem.AGG_STATEMENT_FBACK_RANK_AVG = 0
	    foundItem.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG = 0

	    aggDataset.push(foundItem)
	}


	foundItem.AGG_DATA_COUNT++
	foundItem.AGG_STATEMENT_FBACK_LAST_WEEK_COUNT = foundItem.AGG_STATEMENT_FBACK_COUNT // last/prev week
	foundItem.AGG_STATEMENT_FBACK_COUNT += d.STATEMENT_FBACK_COUNT
	//foundItem.AGG_STATEMENT_FBACK_PRO_COUNT = Math.floor((Math.random() * foundItem.AGG_STATEMENT_FBACK_COUNT) + 0)

	foundItem.AGG_STATEMENT_FBACK_RANK_AVG = round(((foundItem.AGG_STATEMENT_FBACK_RANK_AVG * (foundItem.AGG_DATA_COUNT - 1)) + d.STATEMENT_FBACK_RANK) / foundItem.AGG_DATA_COUNT, 3)

	log.trace("calcStatementTableDatasetTailV2():  foundItem.AGG_STATEMENT_FBACK_RANK_AVG =", foundItem.AGG_STATEMENT_FBACK_RANK_AVG)

	foundItem.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG = ((foundItem.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG * (foundItem.AGG_DATA_COUNT - 1)) + d.STATEMENT_FBACK_POSITIVE_RATIO) / foundItem.AGG_DATA_COUNT
	log.trace("calcStatementTableDatasetTailV2():  foundItem.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG = ", foundItem.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG)
	
    })

    aggDataset.sort((a,b) => {
        return a["AGG_STATEMENT_FBACK_RANK_AVG"] - b["AGG_STATEMENT_FBACK_RANK_AVG"]
    })
    
    log.debug("calcStatementTableDatasetTailV2(): V2: aggDataset =", aggDataset)
    
    return {
	inputDataset: inputDataset,
	inputDataCount: inputDataCount,
	resultDataset: aggDataset,
	resultDataCount: aggDataset.length,
	inputFirstWeekNumber: inputFirstWeekNumber,
	inputLastWeekNumber: inputLastWeekNumber,
	cutoffWeekNumber: cutoffWeekNumber,
//	resultIssueFbackCount: resultIssueFbackCount,
//	resultFirstWeekNumber: resultFirstWeekNumber,
//	resultLastWeekNumber: resultLastWeekNumber,
//	resultDistinctWeeks: resultDistinctWeeks,
//	resultDistinctWeeksCount: resultDistinctWeeks ? resultDistinctWeeks.length : undefined,
    }
    
}


const calcStatementTableDatasetTail = (inputDataset, tailWeekCount) => {
    log.trace("calcStatementTableDatasetTail(): inputDataset =", inputDataset)
    log.trace("calcStatementTableDatasetTail(): tailWeekCount =", tailWeekCount)
    // log.trace("calcStatementTableDatasetTail(): this.state.issue.uuid =", this.state.issue.uuid)
    log.trace("calcStatementTableDatasetTail(): again1")

    const {
	inputFirstWeekNumber,
	inputLastWeekNumber,
	inputDataCount,
	cutoffWeekNumber,
//	tailDataset: resultDataset
    } = tailDataset(inputDataset, tailWeekCount)

    log.trace("calcStatementTableDatasetTail(): again2")
    
    const aggDataset = []

    inputDataset.forEach(d => {
	let foundItem

	log.trace("calcStatementTableDatasetTail(): d = ", d)
	
	aggDataset.forEach(i => {
	    if(i.issue.slug === d.issue.slug
		&& i.statement.slug === d.statement.slug) {
		foundItem = i
	    }
	})

	if(!foundItem) {
	    foundItem =  {
		issue: { 
		    uuid: d.issue.uuid,
		    slug: d.issue.slug,
		    txt: d.issue.txt,
		    level: d.issue.level
		},
		statement: {
		    uuid: d.statement.uuid,
		    slug: d.statement.slug,
		    txt: d.statement.txt,
		},
		
		LEVELS: d.LEVELS
	    }

	    foundItem.AGG_DATA_COUNT = 0
	    foundItem.AGG_STATEMENT_FBACK_COUNT = 0
	    foundItem.AGG_STATEMENT_FBACK_LAST_WEEK_COUNT = 0
	    foundItem.AGG_STATEMENT_FBACK_RANK_AVG = 0
	    foundItem.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG = 0

	    aggDataset.push(foundItem)
	}


	foundItem.AGG_DATA_COUNT++
	foundItem.AGG_STATEMENT_FBACK_LAST_WEEK_COUNT = foundItem.AGG_STATEMENT_FBACK_COUNT // last/prev week
	foundItem.AGG_STATEMENT_FBACK_COUNT += d.STATEMENT_FBACK_COUNT
	//foundItem.AGG_STATEMENT_FBACK_PRO_COUNT = Math.floor((Math.random() * foundItem.AGG_STATEMENT_FBACK_COUNT) + 0)

	foundItem.AGG_STATEMENT_FBACK_RANK_AVG = round(((foundItem.AGG_STATEMENT_FBACK_RANK_AVG * (foundItem.AGG_DATA_COUNT - 1)) + d.STATEMENT_FBACK_RANK) / foundItem.AGG_DATA_COUNT, 3)

	log.trace("calcStatementTableDatasetTail():  foundItem.AGG_STATEMENT_FBACK_RANK_AVG =", foundItem.AGG_STATEMENT_FBACK_RANK_AVG)

	foundItem.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG = ((foundItem.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG * (foundItem.AGG_DATA_COUNT - 1)) + d.STATEMENT_FBACK_POSITIVE_RATIO) / foundItem.AGG_DATA_COUNT
	log.trace("calcIssueTableDatasetTail():  foundItem.AGG_ISSUE_FBACK_POSITIVE_RATIO_AVG = ", foundItem.AGG_STATEMENT_FBACK_POSITIVE_RATIO_AVG)
	
    })

    aggDataset.sort((a,b) => {
        return a["AGG_STATEMENT_FBACK_RANK_AVG"] - b["AGG_STATEMENT_FBACK_RANK_AVG"]
    })
    

    return {
	inputDataset: inputDataset,
	inputDataCount: inputDataCount,
	resultDataset: aggDataset,
	resultDataCount: aggDataset.length,
	inputFirstWeekNumber: inputFirstWeekNumber,
	inputLastWeekNumber: inputLastWeekNumber,
	cutoffWeekNumber: cutoffWeekNumber,
//	resultIssueFbackCount: resultIssueFbackCount,
//	resultFirstWeekNumber: resultFirstWeekNumber,
//	resultLastWeekNumber: resultLastWeekNumber,
//	resultDistinctWeeks: resultDistinctWeeks,
//	resultDistinctWeeksCount: resultDistinctWeeks ? resultDistinctWeeks.length : undefined,
    }
    
}

const getStateName = (stateCode) => {
    
    let stateName
    switch(stateCode) {
    case "CA":
	stateName = "California"
	break;
    case "AZ":
	stateName = "Arizona"
	break;
    default:
	stateName = stateCode
    }

    return stateName
}


const genUUID = () => {
    const slug = slugid.v4() // Qzm3o_L6Q4GP7Mw1c_vaSg
    const uuid = slugid.decode(slug) // 4339b7a3-f2fa-4381-8fec-cc3573fbda4a
    return { uuid: uuid, slug: slug }
}

//
// new-arch
//
// just use readUserData for it right now, it's simpler
// we don't need a separate call for this yet
/*
const getUser = (user, callbacks) => {
    log.trace("getUser(): START")
    log.trace("getUser(): user =", user)
    log.trace("getUser(): FINISH")
}
*/

const writeFback = async (fback, callbacks) => { 
    log.trace("writeFback(): START")
    log.trace("writeFback(): getVaporURL() =", getVaporURL())
    log.trace("writeFback(): fback =", fback)

    const realVariables = {
	"userUUID": fback.user.uuid,
	"userSlug": fback.user.slug,
	"set": fback.set,
	"issue": fback.issue, // some additional issue level attributes
	"statements": fback.statements
    }

    //log.trace("writeFback(): realVariables =", realVariables)

    //const variables = fakeVariables
    const variables = realVariables

    const writeFbackMutationConfig = { 
	mutation: WRITE_FBACK_MUTATION,
	variables: variables
    }

    log.trace("writeFback(): variables =", variables)

    const gqlClient = getGqlClient()

    const writeFbackResult = await gqlClient.mutate(writeFbackMutationConfig)

    log.trace("writeFback(): writeFbackResult =", writeFbackResult)

    if(writeFbackResult
       && !writeFbackResult.errors
       && writeFbackResult.data
       && writeFbackResult.data.writeFback !== null
       && writeFbackResult.data.writeFback !==""
      ) {
	callbacks.onResult(writeFbackResult)
    } else  {
	callbacks.onError(writeFbackResult)
    }
}

const getDrives = async (slug, callbacks)  => {
    log.debug("getDrives(): start...")

    let queryConfig = {
	//        query: ReadUserDataQuery,
	query: GET_DRIVES_QUERY,
        variables: {
	    filters:  {
		likeSlug: slug,
		isLatest: true,
		isActive: true
	    }
        }
    }

    const gqlClient = getGqlClient()
    
    await gqlClient.query(queryConfig)
        .then(result => {
	    log.debug("getDrives(): PROMISE: result =", result)
	    if(result.data && result.data.drives && result.data.drives[0])  {
		callbacks.onResult(result.data.drives[0])
	    } else {
		callbacks.onError(`Did not get a drive.slug = ${slug}`)
	    }
	}).catch (error => {
	    callbacks.onError(error.message)
	})

    callbacks.onFinish()
}


const readUserData = (user, callbacks) => {
    log.trace("readUserData(): START")
    log.trace("readUserData(): getVaporURL() =", getVaporURL())
    log.trace("readUserData(): user =", user)

    const gqlClient = getGqlClient()

    log.trace("readUserData(): gqlClient =", gqlClient)

    let readUserDataConfig = {
	//        query: ReadUserDataQuery,
	query: READ_USER_DATA_QUERY,
        variables: {
	    userUUID: user.uuid,
	    userEmail: user.email
        }
    }

    log.trace("readUserData(): before promise")
    gqlClient.query(readUserDataConfig)
        .then(result => {
	    log.trace("readUserData(): PROMISE: result =", result)
	    if(!result.data.user) { // might need it at some point
		log.trace("readUserData(): PROMISE: calling onError")
		callbacks.onError(result)
	    } else  {
		log.trace("readUserData(): PROMISE: calling onResult")
		//callbacks.onResult(result)

		// TODO: this is temporary since we don't handle both uuid and slug
		//       in statements and issues, set uuid = slug for both right now
		const resultCopy = JSON.parse(JSON.stringify(result))
		log.trace("readUserData(): PROMISE: initial: resultCopy =", resultCopy)
		resultCopy.data.user.statements.forEach(statement => {
		    log.trace("readUserData(): PROMISE: statement =", statement)
		    // we don't need this anymore
		    // statement.issue.uuid = statement.issue.slug
		    // statement.uuid = statement.slug
		})

		log.trace("readUserData(): PROMISE: before return: resultCopy =", resultCopy)

		callbacks.onResult(resultCopy)
	    }
	}).catch (error => {
	    // this is normal here when we can't find a user
	    log.trace("readUserData(): PROMISE: caught error, could not find a user")
	    log.trace("readUserData(): PROMISE: callbacks =", callbacks)
	    log.trace("readUserData(): PROMISE: error =", JSON.stringify(error, null, " "))
	    log.trace("readUserData(): PROMISE: error.message =", error.message)
	    callbacks.onError(error.message)
	})
    
    log.trace("readUserData(): FINISH")
}

// this creates monday morning Mon Feb 15 2021 00:00:00 GMT-0800 (Pascific Standard Time)
const createYearWeekAggDate = (yearNumber, weekNumber) => {
    return add(new Date(yearNumber,0,1,0), {
	weeks: weekNumber, 
	//days: 3
	days: 2 // have this hit on Sunday instead of Monday
    })
}

const createYearWeekDayAggDate = (yearNumber, weekNumber, dayNumber) => {
    // this additions are cumulative, so we need to do some math as week ends on Friday
    // so we need to minus those dates
    return add(new Date(yearNumber,0,1,0), {
	weeks: weekNumber, 
	// days: dayNumber
	days: -(5 - dayNumber)
    })
}

// put atttributes like current, up/down, etc.
const enrichTrend = (trend) => {
    let prevValue
    let flashItemNumber = 1
    let flashItemDirection
    let flashItemType
    let itemLastNumber = trend.length
    
    const richTrend = trend
	  .sort((a,b) => {
	      const am = moment(a.timestamp)
	      const bm = moment(b.timestamp)
	      return am.diff(bm)
	  })    
	  .map(d => {
	      if(flashItemNumber === itemLastNumber) {
		  flashItemType = "current"
	      } else if(flashItemNumber === (itemLastNumber - 1)) {
		  flashItemType = "lastWeek"
	      } else {
                  flashItemType = undefined
              }
	      if(prevValue) {
		  if(prevValue < d.value) {
		      flashItemDirection = "up"
		  } else if(prevValue > d.value) {
		      flashItemDirection = "down"
		  } else {
		      flashItemDirection = "same"
		  }
	      } else {
		  flashItemDirection = "same"
              }
	      prevValue = d.value
	      return {
		  ...d,
		  flashValue: d.value,
		  flashTimestamp: moment(d.timestamp).toDate(),
		  flashItemNumber: flashItemNumber++,
		  flashItemType: flashItemType,
		  flashItemDirection: flashItemDirection
	      }
	  })
    return richTrend
}

const addGraphTimestamps = trend => {
    const isDaily = trend.find(stat => stat.DAY_N > 0) ? true : false
    log.trace("addGraphTimestamps(): DAILY: isDaily =", isDaily)
    
    if(isDaily) {
	return trend.map(stat => {
	    const aggTimestamp = createYearWeekDayAggDate(stat.YEAR_N, stat.WEEK_N, stat.DAY_N)
            let timestamp = aggTimestamp // default

	    log.trace("addGraphTimestamps(): DAILY: aggTimestamp =", aggTimestamp)
	    let todayTimestamp = new Date()
//            if(getWeek(aggTimestamp) > getWeek(todayTimestamp)) {
//		timestamp = todayTimestamp
//            }
	    return {
		...stat,
		timestamp: timestamp
	    }
	})
    } else {
	return trend.map(stat => {
	    const aggTimestamp = createYearWeekAggDate(stat.YEAR_N, stat.WEEK_N)
            let timestamp = aggTimestamp // default
	    let todayTimestamp = new Date()
            if(getWeek(aggTimestamp) > getWeek(todayTimestamp)) {
		timestamp = todayTimestamp
            }
	    return {
		...stat,
		timestamp: timestamp
	    }
	})
    }
}

const initDrives = context => {
    // this is in any case
    let defaultDrive = {
        slug: "all",
        txt: "All Issues",
        isSelected: true
    }
    
    let currentDrive = defaultDrive // this might change below if we've supplied a slug
    const drives = [defaultDrive]
    

    const { driveSlug } = context.props.match.params

    // we have a slug
    if(driveSlug && driveSlug !== defaultDrive.slug) {
        drives.forEach(drive => drive.isSelected = false)
        const newDrive = {
            slug: driveSlug,
            txt: "Loading...",
            isSelected: true
        }

        drives.push(newDrive)
        currentDrive = newDrive
    }

    console.log("initDrives(): returning = ", {drives, currentDrive})

    
    return {drives, currentDrive}
}

const handleDriveChange = context => change => {

    const {history, match} = context.props

    if(!context.state.drives) {
	//newUrl = `/drives/${newDrive.slug}${match.path}`
	newUrl = `/drives/all/issues`
	history.push(newUrl)
    }

    const newDrives = deepCopy(context.state.drives)
          .map(drive => (drive.slug === change.drive.slug
                         ? {...drive, isSelected: true}
                         : {...drive, isSelected: false}))

    const newDrive = newDrives.filter(drive => drive.isSelected)[0]
    log.debug("handleDriveChange(): newDrive = ", newDrive)
    
    context.setState({
        drive: newDrive, // new current drive
        drives: newDrives
    })

    // push to history
    log.debug("handleDriveChange(): history = ", history)
    log.debug("handleDriveChange(): match = ", match)

    const { driveSlug } = context.props.match.params
    let newUrl
    if(match.path.includes("/drives")) {
	newUrl = match.url.replace(driveSlug, newDrive.slug)
    } else {
	newUrl = `/drives/${newDrive.slug}${match.path}`
    }
    history.push(newUrl)
}

const genUrl = context => path => {
    const { match } = context.props
    const { driveSlug } = match.params
    
    let newUrl
    if(match.path.includes("/drives")) {
	newUrl = `/drives/${driveSlug}${path}`
    } else {
	newUrl = path
    }
    
    return newUrl
}

const handleDriveResult = context => result => {
    log.debug("handleDriveResult(): result = ", result)
    const newDrive = {
        slug: result.slug,
        txt: result.txt,
        isSelected: false
    }
    log.debug("handleDriveResult(): newDrive = ", newDrive)
    
    const newDrives = context.state.drives ? deepCopy(context.state.drives) : []
    const existingDriveIndex = newDrives.findIndex(drive => drive.slug === newDrive.slug)
    if(existingDriveIndex !== -1) {
        newDrives[existingDriveIndex].txt = newDrive.txt // we're just updating, we already have it
    } else {
        newDrives.push(newDrive)
    }
    
    context.setState({
        drives: newDrives
    })
}

const handleDriveError = context => error => {
    log.error("handleDriveResult(): error = ", error)
}

const handleDriveFinish = context => () => {
    const {drives, currentDrive} = context.state
    log.debug("handleDriveFinish(): drives =", drives)
    log.debug("handleDriveFinish(): currentDrive =", currentDrive)
    // if some drives were not loaded, we've ran out of issues there
    
    //const validDrives = drives.filter(drive => drive.txt !== "Loading...")
    let validDrives = []
    if(drives) {
	validDrives = drives.filter(drive => drive.txt !== "Loading...")
    }
    
    log.debug("handleDriveFinish(): validDrives =", validDrives)
    if(!validDrives.find(drive => drive.isSelected)) {
	log.debug("handleDriveFinish(): there are no valid drives that are selected")
	// select the "all" drive
	context.setState({ drives: validDrives })
	handleDriveChange(context)({drive: { slug: "all"}})
    }
}

const manageDrives = context => statements => {

    const allDrives = statements.map(statement => {
        return statement.drive
    })

    log.debug("manageDrives(): allDrives = ", allDrives)
    const distinctDriveSlugs = distinct(allDrives, drive => drive.slug)
    log.debug("manageDrives(): distinctDrives = ", distinctDriveSlugs)

    if(distinctDriveSlugs && distinctDriveSlugs.length != 0) {
        distinctDriveSlugs.forEach(slug => {
            getDrives(slug, {
                onResult: handleDriveResult(context),
                onError: handleDriveError(context),
		onFinish: handleDriveFinish(context)
            })
        })
    } else {
	log.debug("manageDrives(): no drives")
	handleDriveFinish(context)()
    }

}

const genTimeRange = (rangeLabel) => {

    let retObj
    const now = new Date()
    
    switch (rangeLabel) {
    case "last7Days":
	retObj = {
	    fromTimestamp: sub(now, { days: 7 }).toISOString(),
	    toTimestamp: now.toISOString()
	}
	break
    case "last14Days":
	retObj = {
	    fromTimestamp: sub(now, { days: 14 }).toISOString(),
	    toTimestamp: now.toISOString()
	}
	break
    case "lastMonth":
	retObj = {
	    fromTimestamp: sub(now, { days: 30 }).toISOString(),
	    toTimestamp: now.toISOString()
	}
	break
    default:
	retObj = {
	    fromTimestamp: '2021-01-01T00:00:00.000Z',
	    toTimestamp: '2031-01-01T00:00:00.000Z'
	}
    }
    return retObj
}

const parseUtcDate = (dateString, _format) => {
    return zonedTimeToUtc(parse(dateString,_format ? _format : "EEE MMM d yyyy H:mm:ss 'GMT'xx", new Date()),'UTC')
}


const genRichTickValues_old = tickValues => {
    const sortedTickValues = [...tickValues].sort((a,b) => {
	if(a > b) return 1
	return -1
    })

//    console.log("tickValues =", tickValues)
//    console.log("sortedTickValues =", sortedTickValues)

const firstIndex = 0
const lastIndex = sortedTickValues.length - 1
let prevDistance = 0
const minDistance = 2
let isPrevVisible = false

    const richTickValues = sortedTickValues.map((tick, i, arr) => {
	let retObj = { tick }
	if(i === firstIndex || i === lastIndex) {
	    retObj = {...retObj, isVisible: true}
	    isPrevVisible = true
	    return retObj
	}

	//    const prev = arr[i-1]
	//    console.log("prev =", prev)
	//    const prevDistance = differenceInDays(tick, prev)
	//    console.log("prevDistance =", prevDistance)
	//    if(prevDistance <= minDistance && !isPrevVisible) {
	if(i === lastIndex - 1) {
	    // don't display one before last
	    isPrevVisible = false
	    retObj = {...retObj, isVisible: false}
	} else if(!isPrevVisible) {
	    isPrevVisible = true
	    retObj = {...retObj, isVisible: true}
	} else {
	    isPrevVisible = false
	    retObj = {...retObj, isVisible: false}
	}
	
	return retObj
    })

    return richTickValues
}


const genRichTickValues = (tickValues, rollup, depth) => {
    let richTickValues = []

    const sortedTickValues = [...tickValues].sort((a,b) => {
	if(a > b) return 1
	return -1
    })

    log.debug("genRichTickValues(): DAILY: sortedTickValues =", sortedTickValues)

    const firstTimestamp = sortedTickValues[0]
    const lastTimestamp = sortedTickValues[sortedTickValues.length - 1]

    log.debug("genRichTickValues(): DAILY: firstTimestamp =", firstTimestamp)
    log.debug("genRichTickValues(): DAILY: lastTimestamp =", lastTimestamp)

    richTickValues.push({peg: firstTimestamp, isTextVisible: true})
    richTickValues.push({peg: lastTimestamp, isTextVisible: true})

    const getMiddleWeekTimestamp = (firstTimestamp, lastTimestamp) => {
	const diff = differenceInWeeks(lastTimestamp, firstTimestamp)
	log.trace("getMiddleWeekTimestamp(): DAILY: diff =", diff)
	const newTimestamp = set(addWeeks(firstTimestamp, Math.round(diff / 2)), {hours: 0})
	return newTimestamp
    }


    const getMiddleDayTimestamp = (firstTimestamp, lastTimestamp) => {
	const diff = differenceInDays(lastTimestamp, firstTimestamp)
	log.trace("getMiddleDayTimestamp(): DAILY: diff =", diff)
	const newTimestamp = set(addDays(firstTimestamp, Math.round(diff / 2.0)), {hours: 0})
	return newTimestamp
    }
    
    const addMiddleWeeks = (richTickValues, t1, t2, depth, maxDepth) => {
	if(depth >= maxDepth) return

	const mid = getMiddleWeekTimestamp(t1, t2)
	log.trace("addMiddleWeeks(): DAILY: depth =", depth)
	log.trace("addMiddleWeeks(): DAILY: maxDepth =", maxDepth)

	if(mid.getTime() === t1.getTime() || mid.getTime() === t2.getTime()) {
	    log.trace("addMiddleWeeks(): DAILY: mid same")
	} else {
	    log.trace("addMiddleWeeks(): DAILY: mid new")
	    richTickValues.push({peg: mid, isTextVisible: true})
	    addMiddleWeeks(richTickValues, t1, mid, depth + 1, maxDepth)
	    addMiddleWeeks(richTickValues, mid, t2, depth + 1, maxDepth)
	}
    }

    const addMiddleDays = (richTickValues, t1, t2, depth, maxDepth) => {
	if(depth >= maxDepth) return

	const mid = getMiddleDayTimestamp(t1, t2)
	log.trace("addMiddleDays(): DAILY: depth =", depth)
	log.trace("addMiddleDays(): DAILY: maxDepth =", maxDepth)

	if(mid.getTime() === t1.getTime() || mid.getTime() === t2.getTime()) {
	    log.trace("addMiddleDays(): DAILY: mid same")
	} else {
	    log.trace("addMiddleDays(): DAILY: mid new")
	    richTickValues.push({peg: mid, isTextVisible: true})
	    addMiddleDays(richTickValues, t1, mid, depth + 1, maxDepth)
	    addMiddleDays(richTickValues, mid, t2, depth + 1, maxDepth)
	}
    }

    if(rollup === "WEEK") {
	//const diff = Math.floor(differenceInHours(lastTimestamp, firstTimestamp)/(7*24))|0
	//const diff = differenceInWeeks(lastTimestamp, firstTimestamp)
	//	log.debug("genRichTickValues(): DAILY: diff =", diff)
	//const newTimestamp = set(addWeeks(firstTimestamp, 2), {hours: 0})
	addMiddleWeeks(richTickValues, firstTimestamp, lastTimestamp, 0, depth)
    } else if(rollup === "DAY") {
	addMiddleDays(richTickValues, firstTimestamp, lastTimestamp, 0, depth)
    }
    

    // we should find half point and put a marker there
    
    return richTickValues
}

const genRichTickValues_old2 = (tickValues, rollup) => {
    let richTickValues = []

    const sortedTickValues = [...tickValues].sort((a,b) => {
	if(a > b) return 1
	return -1
    })

    log.debug("genRichTickValues(): DAILY: sortedTickValues =", sortedTickValues)

    const firstTimestamp = sortedTickValues[0]
    const lastTimestamp = sortedTickValues[sortedTickValues.length - 1]

    log.debug("genRichTickValues(): DAILY: firstTimestamp =", firstTimestamp)
    log.debug("genRichTickValues(): DAILY: lastTimestamp =", lastTimestamp)

    let done = false
    let i = 0
    let minDistance = 1
    let prev = -minDistance - 1

    while(!done) {
	let newTick

	if(i === 0) {
	    newTick = {peg: sortedTickValues[i]}
	} else {
	    if(rollup === "DAY") {
		newTick = {peg: add(richTickValues[i - 1].peg, { hours: 24 })}
	    } else {
		newTick = {peg: add(richTickValues[i - 1].peg, { hours: 24 * 7 })}
	    }
	}

	newTick = {
	    ...newTick,
	    i 
	}


	if(sortedTickValues.find(t => t.getTime() === newTick.peg.getTime())) {
	    newTick = {
		...newTick,
		tick: newTick.peg
	    }
	}

	if((i - prev) > minDistance) {
	    // this should be visible, but check the one ahead first
	    // if it has a tick and is less than minDistance (meaning it woul dnot be display)
	    // don't set visible here, but subtract 1 from previous distance so that the next one
	    // will be visible instead
	    if(!newTick.tick) {
		// look ahead
		//if((i + 1) - prev > minDistance) {
		//		    prev - 1
		//}
		newTick = {
		    ...newTick,
		    isTextVisible: true
		}
		prev = i
	    } else {
		newTick = {
		    ...newTick,
		    isTextVisible: true
		}
		prev = i
	    }
	}

	richTickValues.push(newTick)

	if(newTick.peg.getTime() >= lastTimestamp.getTime()) {
	    log.debug("genRichTickValues(): DAILY: date exiting at i =", i)
	    done = true
	} else {
	// in the end
	    i++
	    if(i >= 20) { // if there is a bug in date, exist at max i
		log.debug("genRichTickValues(): DAILY: trigger exiting at i =", i)
		done = true
	    }
	}
    }
    
    return richTickValues
}



const genRichTickValues_old1 = (tickValues, rollup) => {
    const sortedTickValues = [...tickValues].sort((a,b) => {
	if(a > b) return 1
	return -1
    })

    const firstTimestamp = sortedTickValues[0]
    const lastTimestamp = sortedTickValues[sortedTickValues.length - 1]
    

//    console.log("allTickValues =", allTickValues)
//    console.log("sortedTickValues =", sortedTickValues)
//    console.log("firstTimestamp =", firstTimestamp)
//    console.log("lastTimestamp =", lastTimestamp)

    let richTickValues = []
    let done = false
    let i = 0
    let minDistance = 1
    let prev = -minDistance - 1
    while(!done) {
	let newTick
	
	if(i === 0) {
	    newTick = {peg: sortedTickValues[i]}
	} else {
	    //newTick = {peg: add(richTickValues[i - 1].peg, { hours: 24 })}
	}

	newTick = {
	    ...newTick,
	    i 
	}


	if(sortedTickValues.find(t => t.getTime() === newTick.peg.getTime())) {
	    newTick = {
		...newTick,
		tick: newTick.peg
	    }
	}

	// minDistance should be here
	//if(i%2 === 0) { // 0 is always visible
	//	    newTick = {
	//		...newTick,
	//		isTextVisible: true
	//	    }
	//	}

	if((i - prev) > minDistance) {
	    // this should be visible, but check the one ahead first
	    // if it has a tick and is less than minDistance (meaning it woul dnot be display)
	    // don't set visible here, but subtract 1 from previous distance so that the next one
	    // will be visible instead
	    if(!newTick.tick) {
		// look ahead
		//if((i + 1) - prev > minDistance) {
		//		    prev - 1
		//}
		newTick = {
		    ...newTick,
		    isTextVisible: true
		}
		prev = i
	    } else {
		newTick = {
		    ...newTick,
		    isTextVisible: true
		}
		prev = i
	    }
	}

	richTickValues.push(newTick)

	console.log("newTick.peg =", newTick.peg)
	console.log("lastTimestamp =", lastTimestamp)

	if(newTick.peg.getTime() >= lastTimestamp.getTime()) {
	    done = true
	    console.log("DAILY: date existing at i =", i)
	} else {
	    i++
	    if(i > 20) {
		console.log("DAILY: trigger exisitn at i =", i)
		done = true
	    }
	}
    }

    // NEXT
    // cycle through everytone and for each one that has a tick and is not visible, move the visible up to the tick

    richTickValues.forEach((richTick, i) => {
	if(richTick.tick && (richTick.isTextVisible === 'undefined' || richTick.isTextVisible !== true)) {
	    console.log("ghost at i =",i)
	}
    })
    
    return richTickValues
}


export {
    // idash
    getIssuesFilters,
    getStatementsStatsData,
    getIssuesStatsData,
    // contacts and other app items
    //getAllData,
    getUserFromData,
    getContactsFromData,
    getIssuesFromData,
    getStatementsFromData,
    getGqlClient,
    // idash new
    getVaporURL, // we need to export this to test
    //getTrends,
    issueFilter,
    weekFilter,
    sumReducer,
    avgReducer,
//    maxNumberReducer,
//    minNumberReducer,
    fieldFilter,
    quickRegisterNewUser,
    // refactoring
    getStateName,
    getSubGeoCodes,
//    calcTableDatasetMaxWeekOnly,
//    calcMapDatasetMaxWeekOnly,
//    calcMapDatasetWindow,
    calcIssueMapDatasetTail,
    calcIssueTableDatasetTail,
    // for sdash
    calcStatementTableDatasetTail,
    genUUID,
    //getUser,
    // new-arch
    readUserData,
    getContactsFromUserData,
    getIssuesFromUserData,
    getStatementsFromUserData,
    writeFback,
    getIssueTrends,
    getStatementTrends,
    createYearWeekAggDate,
    enrichTrend,
    addGraphTimestamps,
    getDrives,
    validateGeo,
    handleDriveResult,
    handleDriveError,
    handleDriveChange,
    initDrives,
    manageDrives,
    genUrl,
    weighRanksByFbackCounts,
    getStatementTrendsV2,
    calcStatementTableDatasetTailV2,
    genTimeRange,
    genRichTickValues,
    getIssueTrendsV2,
}
